
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import axios from "axios";
import useEmirateFromCoordinates, { BACKEND_URL, fastApiCall, fastApiClient, PLACEHOLDER_IMAGE } from "../common/Common";
import { useLocation } from "../../contexts/LocationContext";
import Hls from "hls.js";
import '../home/Home.css';
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import { FeedMediaContent, useMediaHeight, MediaType } from "./FeedMediaContent ";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
// import businessicon from '../../assets/home-images/businessicon.jpg';
// import plusicon from '../../assets/home-images/plusicon.png';
// import messageicon from '../../assets/home-images/messageicon.png';
// import bellicon from '../../assets/home-images/bellicon.png';
// import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
// import videos from '../../assets/home-images/videos.png';
// import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
// import menu from '../../assets/home-images/menu.png';
// import downarrow from '../../assets/home-images/downarrow.png';
import campopup from '../../assets/home-images/cam-popup.png';
import vidpopup from '../../assets/home-images/vid-popup.png';
import offerpopup from '../../assets/home-images/offer-popup.png';
import eventpopup from '../../assets/home-images/event-popup.png';
import spotlightpopup from '../../assets/home-images/spotlight-popup.png';
import carouselpopup from '../../assets/home-images/carouselpopup.png';


//post
// import feedcard1 from '../../assets/home-images/mid-section-images/feedcard1.png';
import threedot from '../../assets/home-images/mid-section-images/threedot.png';
// import post1 from '../../assets/home-images/mid-section-images/post1.png';
import hearticon from '../../assets/home-images/mid-section-images/hearticon.png';
import commenticon from '../../assets/home-images/mid-section-images/commenticon.png';
import shareicon from '../../assets/home-images/mid-section-images/shareicon.png';
import img1 from '../../assets/home-images/mid-section-images/img1.png';
import img2 from '../../assets/home-images/mid-section-images/img2.png';
import img3 from '../../assets/home-images/mid-section-images/img3.png';
import img4 from '../../assets/home-images/mid-section-images/img4.png';
// import mcdonald from '../../assets/home-images/mid-section-images/mcdonald.png';
// import slidepost1 from '../../assets/home-images/mid-section-images/slidepost1.png';
import rotana1 from '../../assets/home-images/mid-section-images/rotana1.png';
import rotana2 from '../../assets/home-images/mid-section-images/rotana2.png';
// import rotanapost1 from '../../assets/home-images/mid-section-images/rotanapost1.png';
// import redheart from '../../assets/home-images/mid-section-images/redheart.png';
// import saved from '../../assets/home-images/mid-section-images/saved.png';
// import profileimg from '../../assets/home-images/mid-section-images/profileimg.png';
// import profileimg1 from '../../assets/home-images/mid-section-images/profileimg1.png';
// import abudhabicafepost from '../../assets/home-images/mid-section-images/abudhabicafepost.png';
// import samirashidpost from '../../assets/home-images/mid-section-images/samirashidpost.png';
import videomute from "../../assets/home-images/mid-section-images/videomute.png";
import videounmute from "../../assets/home-images/mid-section-images/videounmute.png";
import popup_yatch from "../../assets/offers/popup_yatch.png";
import linkicon from "../../assets/home-images/mid-section-images/linkicon.png";
import emoji from "../../assets/home-images/mid-section-images/emoji.png";

//rightsection images
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
// import hotel1 from '../../assets/home-images/right-section-images/hotel1.jpg';
// import hotel2 from '../../assets/home-images/right-section-images/hotel2.png';
// import hotel3 from '../../assets/home-images/right-section-images/hotel3.png';
// import pic1 from '../../assets/home-images/right-section-images/pic1.png';
// import pic2 from '../../assets/home-images/right-section-images/pic2.png';
// import pic3 from '../../assets/home-images/right-section-images/pic3.png';
// import pic4 from '../../assets/home-images/right-section-images/pic4.png';
// import pic5 from '../../assets/home-images/right-section-images/pic5.png';
// import pic6 from '../../assets/home-images/right-section-images/pic6.png';
import AiImage from '../../assets/home-images/right-section-images/AiImage.png';
import AiMobileImage from "../../assets/home-images/AiMobileImage.png";

// import leftarrow from '../../assets/home-images/right-section-images/leftarrow.png';
import circleleftarrow from '../../assets/experience/circleleftarrow.png';
import circlerightarrow from '../../assets/experience/circlerightarrow.png';
import carouselleftarrow from '../../assets/home-images/right-section-images/carouselleftarrow.png';
import carouselrightarrow from '../../assets/home-images/right-section-images/carouselrightarrow.png';

// NO FOLLOW NO CONNECT IMAGE
import no_follow_connect from '../../assets/home-images/no_follow_connect.png';

const data = [
    { img: img1, logo: rotana1, title: "Louvre Abu Dhabi", subtitle: "Louvre Abu Dhabi" },
    { img: img2, logo: rotana2, title: "Shangri-La Qaryat Al Beri", subtitle: "Shangri-La Qaryat Al Beri" },
    { img: img3, logo: rotana1, title: "Desert Safari", subtitle: "Desert safari" },
    { img: img4, logo: rotana2, title: "Louvre Abu Dhabi", subtitle: "Louvre Abu Dhabi" },
    { img: img2, logo: rotana1, title: "Fairmont Abu Dhabi", subtitle: "Fairmont Abu Dhabi" },
    { img: img3, logo: rotana2, title: "Cooper's Abu Dhabi", subtitle: "Cooper's Abu Dhabi" },
];

// Helper function to detect if text is Arabic
const isArabic = (text) => {
    if (!text) return false;
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return arabicPattern.test(text);
};

// Translation cache to store already translated text (persists across page loads)
const translationCache = new Map();

// Frontend translation function using Google Translate free API (optimized with parallel requests and caching)
const translateText = async (text, targetLang = 'en') => {
    try {
        // Check cache first
        const cacheKey = `${text}_${targetLang}`;
        if (translationCache.has(cacheKey)) {
            console.log("Translation from cache");
            return translationCache.get(cacheKey);
        }

        // Detect source language (Arabic = 'ar')
        const sourceLang = isArabic(text) ? 'ar' : 'auto';

        // Google Translate free API endpoint (no API key required)
        const translateUrl = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;

        // Try multiple CORS proxy services in parallel for faster response
        const proxyServices = [
            // Try raw endpoint first (usually fastest)
            `https://api.allorigins.win/raw?url=${encodeURIComponent(translateUrl)}`,
            // Try with get wrapper
            `https://api.allorigins.win/get?url=${encodeURIComponent(translateUrl)}`,
            // Alternative proxy
            `https://corsproxy.io/?${encodeURIComponent(translateUrl)}`,
        ];

        // Helper function to parse Google Translate response
        const parseTranslation = (data) => {
            let translated = '';
            // Handle different response formats
            let responseData = data;

            // If data has contents property (from proxy wrapper)
            if (data.contents) {
                try {
                    responseData = JSON.parse(data.contents);
                } catch (e) {
                    responseData = data;
                }
            }

            // Google Translate returns: [[["translated text", "original text", null, null, 0]], null, "ar"]
            if (Array.isArray(responseData) && Array.isArray(responseData[0])) {
                translated = responseData[0]
                    .map(segment => segment && Array.isArray(segment) && segment[0] ? segment[0] : '')
                    .join('')
                    .trim();
            }
            return translated;
        };

        // Try all proxies in parallel - first one to succeed wins (much faster)
        const proxyPromises = proxyServices.map((proxyUrl, index) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // Reduced to 5 seconds per proxy

            return fetch(proxyUrl, {
                method: 'GET',
                signal: controller.signal,
                headers: {
                    'Accept': 'application/json',
                }
            })
                .then(response => {
                    clearTimeout(timeoutId);
                    if (response.ok) {
                        return response.json().then(data => ({ data, index }));
                    }
                    throw new Error(`Proxy ${index + 1} returned ${response.status}`);
                })
                .catch(error => {
                    clearTimeout(timeoutId);
                    if (error.name !== 'AbortError') {
                        console.warn(`Proxy ${index + 1} failed:`, error.message);
                    }
                    throw error;
                });
        });

        // Use Promise.race to get the first successful response
        try {
            const results = await Promise.allSettled(proxyPromises);

            // Find first successful result
            for (const result of results) {
                if (result.status === 'fulfilled') {
                    const { data, index } = result.value;
                    const translated = parseTranslation(data);

                    if (translated && translated !== text && translated.length > 0) {
                        // Cache the translation
                        translationCache.set(cacheKey, translated);
                        console.log(`Translation successful using proxy ${index + 1}`);
                        return translated;
                    }
                }
            }
        } catch (raceError) {
            console.warn("All parallel requests failed, trying sequential fallback");
        }

        // Fallback: Try proxies sequentially if parallel fails
        for (let i = 0; i < proxyServices.length; i++) {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 5000);

                const response = await fetch(proxyServices[i], {
                    method: 'GET',
                    signal: controller.signal,
                    headers: {
                        'Accept': 'application/json',
                    }
                });

                clearTimeout(timeoutId);

                if (response.ok) {
                    const responseData = await response.json();
                    const translated = parseTranslation(responseData);

                    if (translated && translated !== text && translated.length > 0) {
                        // Cache the translation
                        translationCache.set(cacheKey, translated);
                        console.log(`Translation successful using proxy ${i + 1} (fallback)`);
                        return translated;
                    }
                }
            } catch (proxyError) {
                if (proxyError.name !== 'AbortError') {
                    console.warn(`Proxy ${i + 1} failed:`, proxyError.message);
                }
                continue;
            }
        }

        // If all proxies fail, throw error
        throw new Error("Translation failed - all proxy services unavailable. Please check your internet connection or try again later.");

    } catch (error) {
        console.error("Translation error:", error);
        throw error;
    }
};

// Helper function to calculate discount text - from Experience.js
const getDiscountText = (item, className = "offer-tag") => {
    switch (item.discount_type_id) {
        case 8:
        case 4:
            return <span className={className}>{item.discount_type}</span>;
        case 7:
            return (
                <span className={className}>
                    {item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}
                </span>
            );
        case 5:
            return (
                <span className={className}>
                    Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                </span>
            );
        case 1:
            return item.discount_value && item.discount_price && item.coupon_price ? (
                <>
                    <span className="old-price">AED {item.coupon_price}</span>
                    <span className="new-price">AED {item.discount_price}</span>
                    <span className="separator">|</span>
                    <span className={className}>{item.discount_value}% OFF</span>
                </>
            ) : (
                <span className={className}>AED {item.coupon_price}</span>
            );
        case 10:
            return className === "limited-deals-tag" ? (
                <span className={className}>From AED {item.coupon_price}</span>
            ) : (
                <span className="discount_type_from">
                    From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                </span>
            );
        default:
            return item.discount_type === "Total" ? (
                <span className={className}>{item.discount_value}% OFF</span>
            ) : (
                <span className={className}>{item.discount_type}</span>
            );
    }
};

// Coupon Card Component - matches the uploaded image design
const CouponCard = ({ coupon, isOverlay = false, categoryId = '' }) => {
    if (!coupon) return null;

    return (
        <Link
            to={`/offers/${coupon.coupon_id}/${coupon.category_id || categoryId || 0}`}
            className={`review-post-coupon-card ${isOverlay ? 'review-post-coupon-overlay' : 'review-post-coupon-inline'}`}
        >
            <div className="review-post-coupon-content">
                <div className="review-post-coupon-image">
                    <img
                        src={coupon.coupon_image}
                        alt={coupon.coupon_title || "Coupon"}
                        loading="lazy"
                        onError={(e) => {
                            e.target.src = "/no-image.png";
                        }}
                    />
                </div>
                <div className="review-post-coupon-info">
                    <h4 className="review-post-coupon-title">{coupon.coupon_title}</h4>
                    <p className="review-post-coupon-location">{coupon.location}</p>
                    <div className="review-post-coupon-discount">
                        {getDiscountText(coupon, "review-post-coupon-discount-tag")}
                    </div>
                </div>
            </div>
        </Link>
    );
};

// Hook to detect mobile and tablet (same as FeedMediaContent)
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};

// Review Image Slider Component - Uses same logic as FeedMediaContent
const ReviewImageSlider = ({ post, activeSlide, sliderSettings, coupons = [], categoryId = '' }) => {
    const isMobile = useIsMobile();

    // Determine media type and dimensions
    const hasMultipleImages = post.post_images && post.post_images.length > 1;
    const hasSingleImage = post.post_images &&
        post.post_images.length === 1 &&
        post.post_images[0].post_images;

    let mediaType, mediaHeight, mediaWidth;

    if (hasMultipleImages) {
        mediaType = MediaType.MULTI_POST;
        const firstImage = post.post_images[0];
        mediaHeight = firstImage.height;
        mediaWidth = firstImage.width;
    } else if (hasSingleImage) {
        mediaType = MediaType.IMAGE;
        const image = post.post_images[0];
        mediaHeight = image.height;
        mediaWidth = image.width;
    }

    // Use the same height calculation hook as FeedMediaContent
    const calculatedHeight = useMediaHeight(mediaHeight, mediaWidth, mediaType);

    // Check if original height > 1024px (tall image)
    const isTallMedia = mediaHeight && mediaHeight > 1024;

    // Check if this is view_type 12 (review with image)
    const isViewType12 = post.view_type === 12;

    // For mobile and tablet: use cover and no black background
    // For desktop/webview: use contain for tall media or view_type 12 with black background
    // For view_type 12: always use black background on desktop/webview
    const objectFit = isMobile
        ? 'cover'
        : (isTallMedia || isViewType12 ? 'contain' : 'cover');
    const backgroundColor = isMobile ? 'transparent' : ((isTallMedia || isViewType12) ? '#000' : 'transparent');

    // Render image with coupon overlay - matching FeedMediaContent logic
    // const renderImageWithOverlay = (imgSrc, altText, idx = null) => {
    //     const imgIsTall = idx !== null && post.post_images[idx]?.height && post.post_images[idx].height > 1024;
    //     // For mobile and tablet: use cover and no black background
    //     // For view_type 12: always use black background on desktop/webview
    //     const imgObjectFit = isMobile ? 'cover' : ((imgIsTall || isViewType12) ? 'contain' : 'cover');
    //     const imgBackgroundColor = isMobile ? 'transparent' : ((imgIsTall || isViewType12) ? '#000' : 'transparent');

    //     return (
    //         <div style={{ position: 'relative', width: '100%', height: '100%' }}>
    //             <img
    //                 src={imgSrc}
    //                 alt={altText}
    //                 className="review-image-content"
    //                 style={{
    //                     width: '100%',
    //                     height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
    //                     objectFit: imgObjectFit,
    //                     display: 'block',
    //                     backgroundColor: imgBackgroundColor
    //                 }}
    //             />
    //             {/* Coupon overlay - bottom center */}
    //             {coupons && coupons.length > 0 && (
    //                 <div className="review-post-coupon-overlay-container">
    //                     {coupons.map((coupon, couponIdx) => (
    //                         <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
    //                     ))}
    //                 </div>
    //             )}
    //         </div>
    //     );
    // };

    if (hasMultipleImages) {
        return (
            <div
                className="multi-post-image"
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%'
                }}
            >
                <div className="image-counter">
                    {activeSlide + 1} / {post.post_images.length}
                </div>
                <Slider {...sliderSettings} style={{ height: '100%' }}>
                    {post.post_images.map((img, idx) => {
                        const imgIsTall = img.height && img.height > 1024;
                        // For mobile and tablet: use cover and no black background
                        // For view_type 12: always use black background on desktop/webview
                        const imgObjectFit = isMobile ? 'cover' : ((imgIsTall || isViewType12) ? 'contain' : 'cover');
                        const imgBackgroundColor = isMobile ? 'transparent' : ((imgIsTall || isViewType12) ? '#000' : 'transparent');
                        return (
                            <div
                                className="slide-wrapper"
                                key={idx}
                                style={{
                                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                    width: '100%',
                                    backgroundColor: imgBackgroundColor
                                }}
                            >
                                <img
                                    src={img.post_images}
                                    alt={`Post ${post.id} Image ${idx + 1}`}
                                    className="review-image-content"
                                    style={{
                                        width: '100%',
                                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                        objectFit: imgObjectFit,
                                        display: 'block',
                                        backgroundColor: imgBackgroundColor
                                    }}
                                />
                            </div>
                        );
                    })}
                </Slider>
                {/* Fixed coupon overlay - outside slider, stays fixed over all slides */}
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container review-post-coupon-fixed-overlay">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    } else if (hasSingleImage) {
        // Single Image Post - matching FeedMediaContent logic
        return (
            <div
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden'
                }}
            >
                <img
                    src={post.post_images[0].post_images || PLACEHOLDER_IMAGE}
                    alt={`Post ${post.id} Image`}
                    className="review-image-content"
                    style={{
                        width: '100%',
                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                        objectFit: objectFit,
                        display: 'block'
                    }}
                    onError={(e) => {
                        e.target.src = PLACEHOLDER_IMAGE
                    }}
                />
                {/* Coupon overlay - bottom center */}
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return null;
};

const Home = () => {
    const navigate = useNavigate();
    const navigatetoregisterpage = () => {
        navigate("/register");
    }
    const navigatetologinpage = () => {
        navigate("/login")
    }
    // const [showPopupRotana, setShowPopupRotana] = useState(false);
    // const [showPopupAbuDhabi, setShowPopupAbuDhabi] = useState(false);
    // const toggleRotanaPopup = () => setShowPopupRotana(!showPopupRotana);
    // const toggleAbuDhabiPopup = () => setShowPopupAbuDhabi(!showPopupAbuDhabi);
    const [topcouponpost, setTopcouponpost] = useState([]);
    const [getaways, setGetaways] = useState([]);
    const [placeyoumustvisit, setPlaceyoumustvisit] = useState([]);
    const [youlovethis, setYoulovethis] = useState([]);
    const [postpopup, setPostpopup] = useState(false);
    const [normalpost, setNormalpost] = useState([]);
    const [activeSlide, setActiveSlide] = useState(0); //slider post more than 1
    const [shortvideo, setShortvideo] = useState([]);
    const [shuffledPosts, setShuffledPosts] = useState([]);
    const [shuffledYouLoveThis, setShuffledYouLoveThis] = useState([]);
    const [shuffledPlaceYouMustVisit, setShuffledPlaceYouMustVisit] = useState([]);
    const [shuffledShortVideo, setShuffledShortVideo] = useState([]);
    const [shuffledGetaways, setShuffledGetaways] = useState([]);
    // const [followingStates, setFollowingStates] = useState(
    //     new Array(data.length).fill(false)
    // );
    const [preCalculatedSections, setPreCalculatedSections] = useState({});
    const [globalMute, setGlobalMute] = useState(true);
    const [activeVideoIndex, setActiveVideoIndex] = useState(null);
    // NEW: Infinite scroll state
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isInitialLoading, setIsInitialLoading] = useState(true); // For shimmer on initial load
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const observer = useRef();
    const popupRef = useRef(null);
    const [expand, setExpand] = useState({});
    const [textOverflow, setTextOverflow] = useState({});
    // Vendor list search states
    const [homeSearchText, setHomeSearchText] = useState("");
    const [homeVendorList, setHomeVendorList] = useState([]);
    const [allHomeVendors, setAllHomeVendors] = useState([]);
    const [homeSearchCoupons, setHomeSearchCoupons] = useState([]); // Coupons from search-post-list API
    const [homeSearchEvents, setHomeSearchEvents] = useState([]); // Events from get-event-list API
    const [allHomeEvents, setAllHomeEvents] = useState([]); // Store all events for client-side filtering
    const [showHomeDropdown, setShowHomeDropdown] = useState(false);
    const [isHomeSearchLoading, setIsHomeSearchLoading] = useState(false); // Vendors loading
    const [isHomeCouponsLoading, setIsHomeCouponsLoading] = useState(false); // Coupons loading
    const [isHomeEventsLoading, setIsHomeEventsLoading] = useState(false); // Events loading
    const homeSearchDebounceTimerRef = useRef(null);
    const homeSearchBoxRef = useRef(null);
    const homeDropdownRef = useRef(null);
    const sliderRefs = useRef({});
    const middleSectionRef = useRef(null);
    const hasRestoredSectionsRef = useRef(false);
    const isRestoringRef = useRef(false);
    const isPageRefreshRef = useRef(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [reviewExpand, setReviewExpand] = useState({});
    // const [reviewTextOverflow, setReviewTextOverflow] = useState({});
    const [translatedTexts, setTranslatedTexts] = useState({}); // Store translated text for each post
    const [isTranslated, setIsTranslated] = useState({}); // Track if post is currently showing translation
    const [isTranslating, setIsTranslating] = useState({}); // Track if translation is in progress
    const [trendingBrands, setTrendingBrands] = useState([]); // Trending brands (7 shuffled items)
    // Get location from global context
    const { latitude, longitude, selectedState, isLocationLoading, hasRealLocation } = useLocation();
    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const isFetchingTrendingBrandsRef = useRef(false); // Prevent multiple simultaneous calls
    const lastFetchedCoordsRef = useRef(null); // Track last fetched coordinates to avoid refetching
    const [hideFooter, setHideFooter] = useState(false); // HIDE FOOTER AFTER USER REGISTERED
    const [showCommentBox, setShowCommentBox] = useState({}); // Track which posts have comment box open

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); //More Less for Description

    // TABS SECTION DISCOVER FOLLOWING CONNECTION
    const [activeTab, setActiveTab] = useState("discover");
    // TAB FOLLOWING 
    const [hasFollowing, setHasFollowing] = useState(false);
    const [followingPosts, setFollowingPosts] = useState([]); // Separate state for following posts

    const [vendorFollowStatus, setVendorFollowStatus] = useState({}); // Store follow status by user_id

    // SHOWING THE NON FOLLOW VENDOR LIST OF A USER
    const [nonfollowvendorlist, setNonFollowVendorList] = useState();

    // Helper function to check if user is logged in
    const isUserLoggedIn = () => {
        const userId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
        const userStr = localStorage.getItem('user');
        return !!(userId && userStr);
    };


    // Check if user is logged in and hide footer for logged-in users
    useEffect(() => {
        const checkUserLogin = () => {
            const userId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
            const userStr = localStorage.getItem('user');

            // Hide footer if user is logged in
            if (userId && userStr) {
                setHideFooter(true);
            } else {
                setHideFooter(false);
            }
        };

        // Check immediately on mount
        checkUserLogin();

        // Check if new customer was just created (for initial registration flow)
        const newCustomerCreated = localStorage.getItem('newCustomerCreated');
        if (newCustomerCreated === 'true') {
            setHideFooter(true);
            // Clear the flag after checking
            localStorage.removeItem('newCustomerCreated');
        }

        // Listen for custom event when user login state changes
        const handleUserLoginStateChange = () => {
            checkUserLogin();
        };

        window.addEventListener('userLoginStateChanged', handleUserLoginStateChange);

        // Listen for storage changes (in case user logs in/out from another tab)
        const handleStorageChange = (e) => {
            if (e.key === 'user_id' || e.key === 'user') {
                checkUserLogin();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('userLoginStateChanged', handleUserLoginStateChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Track window width for mobile/desktop detection
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const PrevArrow = ({ onClick }) => (
        <div className="custom-arrow prev-arrow" onClick={onClick}>
            <img src={carouselleftarrow} alt="Previous" />
        </div>
    );

    const NextArrow = ({ onClick }) => (
        <div className="custom-arrow next-arrow" onClick={onClick}>
            <img src={carouselrightarrow} alt="Next" />
        </div>
    );

    // Function to get placedeatils settings based on card count
    const getPlacedeatils = (cardCount) => {
        const hasTwoOrLessCards = cardCount <= 2;
        const isWebsiteView = !isMobileView;

        return {
            // dots: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            rows: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            // arrows: true,
            // prevArrow: <PrevArrow />,
            // nextArrow: <NextArrow />,
            swipe: !(hasTwoOrLessCards && isWebsiteView), // Disable swipe if 2 or less cards on website
            draggable: !(hasTwoOrLessCards && isWebsiteView), // Disable drag if 2 or less cards on website
            touchMove: !(hasTwoOrLessCards && isWebsiteView), // Disable touch move if 2 or less cards on website
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        swipe: !(hasTwoOrLessCards && isWebsiteView),
                        draggable: !(hasTwoOrLessCards && isWebsiteView),
                        touchMove: !(hasTwoOrLessCards && isWebsiteView)
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // Mobile view - allow normal behavior
                        swipe: true,
                        draggable: true,
                        touchMove: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // Mobile view - allow normal behavior
                        swipe: true,
                        draggable: true,
                        touchMove: true
                    }
                }
            ]
        };
    };

    // const placedeatils = getPlacedeatils(0); // Default, will be overridden with actual count

    // Check if there are 3 or fewer cards (only for website view)
    const hasThreeOrLessCards = topcouponpost?.posts && topcouponpost.posts.length <= 3;

    const topcouponsettings = {
        dots: false,
        infinite: !hasThreeOrLessCards, // Disable infinite scroll if 3 or less cards
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: !hasThreeOrLessCards, // Hide arrows if 3 or less cards (website view only)
        prevArrow: hasThreeOrLessCards ? <div></div> : <PrevArrow />, // Empty div if disabled
        nextArrow: hasThreeOrLessCards ? <div></div> : <NextArrow />, // Empty div if disabled
        accessibility: true,
        focusOnSelect: true,
        swipe: !hasThreeOrLessCards, // Disable swipe if 3 or less cards
        draggable: !hasThreeOrLessCards, // Disable drag if 3 or less cards
        touchMove: !hasThreeOrLessCards, // Disable touch move if 3 or less cards
        responsive: [
            {
                breakpoint: 2560,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: !hasThreeOrLessCards,
                    swipe: !hasThreeOrLessCards,
                    draggable: !hasThreeOrLessCards,
                    touchMove: !hasThreeOrLessCards,
                    infinite: !hasThreeOrLessCards
                }
            },
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: !hasThreeOrLessCards,
                    swipe: !hasThreeOrLessCards,
                    draggable: !hasThreeOrLessCards,
                    touchMove: !hasThreeOrLessCards,
                    infinite: !hasThreeOrLessCards
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: !hasThreeOrLessCards,
                    swipe: !hasThreeOrLessCards,
                    draggable: !hasThreeOrLessCards,
                    touchMove: !hasThreeOrLessCards,
                    infinite: !hasThreeOrLessCards
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    // Mobile/tablet view - allow normal behavior
                    arrows: true,
                    swipe: true,
                    draggable: true,
                    touchMove: true,
                    infinite: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    // Mobile/tablet view - allow normal behavior
                    arrows: true,
                    swipe: true,
                    draggable: true,
                    touchMove: true,
                    infinite: true
                }
            },
        ],
    };

    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        beforeChange: (current, next) => setActiveSlide(next),
    };

    // Function to get youlovethisSliderSettings based on card count
    const getYoulovethisSliderSettings = (cardCount) => {
        return {
            dots: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            rows: 2,
            autoplay: false,
            // arrows: true,
            // prevArrow: <PrevArrow />,
            // nextArrow: <NextArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        rows: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        rows: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        rows: 1
                    }
                }
            ]
        };
    };

    // const youlovethisSliderSettings = getYoulovethisSliderSettings(0); // Default, will be overridden with actual count

    const shuffleArray = (arr) => {
        if (!arr) return [];
        const copy = [...arr];
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    };

    // Filter normal posts to only include user_type === 0, 1, or 2
    // Handle both string and integer types, explicitly exclude null, undefined
    const filterNormalPostsByUserType = (posts) => {
        if (!posts || !Array.isArray(posts)) return [];
        return posts.filter(post => {
            const userType = post.user_type;
            // Convert to string for consistent comparison, then check if it's "0", "1", or "2"
            const userTypeStr = String(userType);
            // Only allow "0", "1", or "2", explicitly exclude all other values
            return userTypeStr === "0" || userTypeStr === "1" || userTypeStr === "2";
        });
    };

    // NEW: Intersection Observer for infinite scroll
    const lastPostRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPage(prevPage => prevPage + 1);
                observer.current.disconnect();
            }
        });

        if (node) observer.current.observe(node);
    }, [hasMore]);



    const getSectionData = (section) => {
        if (section === "getaways") return getaways.posts;
        if (section === "placeyoumustvisit") return placeyoumustvisit.posts;
        if (section === "youlovethis") return youlovethis.posts;
        if (section === "shortvideosforyou") return shortvideo.posts;
        return [];
    };


    //VIDEO POST OF NORMAL POST FUNCTION
    const initializeVideo = (el, videoUrl, videoIndex) => {
        if (!el || !videoUrl || el.dataset.hlsInitialized) return;

        // Dynamically construct the proxy URL based on environment
        const backendBase = BACKEND_URL.replace('/api/', ''); // Get base URL without /api/

        // Extract just the filename from the video URL
        const filename = videoUrl.split('/').pop();

        // Construct the proxy URL dynamically
        const proxyUrl = `${backendBase}/video/${filename}`;

        // console.log('Loading video from:', proxyUrl); // Debug log

        const playMutedVideo = () => {
            // For iOS: Set muted attribute and property before play
            el.setAttribute('muted', 'true');
            el.muted = true;
            el.volume = 0;
            // Ensure controls are hidden for iOS
            el.controls = false;
            // Auto-play on both desktop and mobile (muted videos can autoplay)
            el.play().catch(err => console.log('Autoplay prevented:', err));
        };

        // ... rest of your HLS code stays the same
        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 90,
                maxBufferLength: 30,
                maxMaxBufferLength: 60,
                maxBufferSize: 60 * 1000 * 1000,

                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                xhrSetup: function (xhr) {
                    xhr.withCredentials = false;
                    xhr.timeout = 10000;
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playMutedVideo();
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                // console.error('HLS Error:', data); // Add error logging
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;

        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            // For iOS native HLS support
            el.setAttribute('muted', 'true');
            el.setAttribute('playsinline', 'true');
            el.setAttribute('webkit-playsinline', 'true');
            el.controls = false;
            el.src = proxyUrl;
            playMutedVideo();
            el.dataset.hlsInitialized = 'true';
        }

        el.dataset.videoIndex = videoIndex;
    };

    const toggleMute = (e) => {
        // Prevent event propagation to avoid navigation
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        const newMuteState = !globalMute;

        // Find the currently active/visible video FIRST (before changing state)
        let activeVideo = null;

        // First, try to find the video using activeVideoIndex
        if (activeVideoIndex !== null) {
            activeVideo = document.querySelector(`video[data-video-index="${activeVideoIndex}"]`);
        }

        // If not found, find the first playing video
        if (!activeVideo) {
            const videos = document.querySelectorAll('video[data-video-index]');
            for (const video of videos) {
                if (!video.paused) {
                    activeVideo = video;
                    break;
                }
            }
        }

        // Update global state
        setGlobalMute(newMuteState);

        // For UNMUTING on mobile: handle active video specially in user interaction context
        if (!newMuteState && activeVideo) {
            // Ensure video is playing (required for audio on mobile)
            if (activeVideo.paused) {
                // Play first, then unmute (all in user interaction context)
                activeVideo.play().then(() => {
                    activeVideo.muted = false;
                    activeVideo.volume = 1;
                }).catch(err => {
                    // console.log('Play/unmute failed:', err);
                    // If it fails, keep muted
                    activeVideo.muted = true;
                    activeVideo.volume = 0;
                    setGlobalMute(true); // Revert state on failure
                });
            } else {
                // Video is already playing - unmute immediately (user interaction context is active)
                activeVideo.muted = false;
                activeVideo.volume = 1;
            }
        }

        // Apply mute state to all videos
        const allVideos = document.querySelectorAll('video[data-video-index]');
        allVideos.forEach(videoElement => {
            // Skip active video if we just handled it for unmute
            if (videoElement === activeVideo && !newMuteState) {
                return; // Already handled above
            }
            videoElement.muted = newMuteState;
            videoElement.volume = newMuteState ? 0 : 1;
        });
    };

    //SHORT VIDEO FUNCTION
    const initializeShortVideo = (el, videoFile) => {
        if (!el || !videoFile || el.dataset.hlsInitialized) return;

        // Dynamic URL construction
        const backendBase = BACKEND_URL.replace('/api/', '');
        const filename = videoFile.split('/').pop();
        const proxyUrl = `${backendBase}/video/${filename}`;

        // console.log('Loading short video from:', proxyUrl);

        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 30,
                maxBufferLength: 20,
                maxMaxBufferLength: 40,
                maxBufferSize: 30 * 1000 * 1000,
                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                capLevelToPlayerSize: true,
                xhrSetup: function (xhr, url) {
                    // Rewrite ALL video segment URLs to use /video/ route
                    const segmentFilename = url.split('/').pop();
                    const correctedUrl = `${backendBase}/video/${segmentFilename}`;
                    xhr.open('GET', correctedUrl, true);
                    xhr.withCredentials = false;
                    xhr.timeout = 8000;
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                // For iOS: Set muted attribute and property before play
                el.setAttribute('muted', 'true');
                el.muted = true;
                el.volume = 0;
                el.controls = false;
                const playPromise = el.play();
                if (playPromise !== undefined) {
                    playPromise.catch(err => console.warn('Autoplay failed', err));
                }
            });

            hls.on(Hls.Events.FRAG_BUFFERED, () => {
                if (el.paused && el.readyState >= 2) {
                    el.play().catch(() => { });
                }
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                // console.error('HLS Error:', data); // Add logging
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;

        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            // For iOS native HLS support
            el.setAttribute('muted', 'true');
            el.setAttribute('playsinline', 'true');
            el.setAttribute('webkit-playsinline', 'true');
            el.controls = false;
            el.src = proxyUrl;
            el.muted = true;
            el.volume = 0;
            el.play().catch(err => console.warn('Autoplay failed', err));
            el.dataset.hlsInitialized = 'true';
        }
    };


    //ACTION TYPE COLOR FOR THE ACTION TYPE
    const getActionTypeColor = (actionTypeId) => {
        switch (actionTypeId) {
            case 1: return "#1877F1";      // primaryBlue
            case 2: return "#7949FF";
            case 3: return "#0C00E8";
            case 4: return "#116C15";
            case 5: return "#04A676";
            case 6: return "#CA09FF";
            case 7: return "#FE0761";
            case 8: return "#FF17E8";
            case 9: return "#E80500";
            case 10: return "#FF7700";
            case 11: return "#03A5C9";
            case 12: return "#0A4A19";
            default: return "#1877F1";
        }
    };

    // Format date to relative time (e.g., "1 Min ago", "2 Hours ago")
    // const formatRelativeTime = (dateString) => {
    //     if (!dateString) return "";

    //     try {
    //         // Parse date string (format: "09-01-2026" or similar)
    //         const dateParts = dateString.split('-');
    //         if (dateParts.length === 3) {
    //             const day = parseInt(dateParts[0], 10);
    //             const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed
    //             const year = parseInt(dateParts[2], 10);
    //             const postDate = new Date(year, month, day);
    //             const now = new Date();
    //             const diffMs = now - postDate;
    //             const diffMins = Math.floor(diffMs / 60000);
    //             const diffHours = Math.floor(diffMs / 3600000);
    //             const diffDays = Math.floor(diffMs / 86400000);

    //             if (diffMins < 1) return "Just now";
    //             if (diffMins < 60) return `${diffMins} ${diffMins === 1 ? 'Min' : 'Mins'} ago`;
    //             if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? 'Hour' : 'Hours'} ago`;
    //             if (diffDays < 7) return `${diffDays} ${diffDays === 1 ? 'Day' : 'Days'} ago`;
    //             return dateString; // Return original if older than a week
    //         }
    //         return dateString;
    //     } catch (e) {
    //         return dateString;
    //     }
    // };


    // Close popup when clicking outside
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (popupRef.current && !popupRef.current.contains(event.target)) {
    //             setShowPopup(false);
    //         }
    //     };
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => document.removeEventListener("mousedown", handleClickOutside);
    // }, []);


    //  FOLLOW UNFOLLOW API
    const savefollower = async (item) => {
        if (!isUserLoggedIn()) {
            setDownloadPopupOpen(true);
            return;
        }

        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
        const itemId = item.user_id || item.id;

        // ✅ Determine current follow status from vendorFollowStatus first, then fallback to item
        const currentFollowStatus = vendorFollowStatus[itemId] !== undefined
            ? vendorFollowStatus[itemId]
            : (item.is_following || false);

        const payload = {
            login_user_id: loggedInUserId,
            user_id: itemId,
            is_following: !currentFollowStatus
        };

        console.log("save followers api", payload);

        // Optimistically update UI first
        const updatedPosts = shuffledPosts.map((post) =>
            (post.user_id === itemId || post.id === itemId)
                ? { ...post, is_following: !currentFollowStatus }
                : post
        );

        setShuffledPosts(updatedPosts);

        // ✅ Update vendorFollowStatus state
        setVendorFollowStatus(prev => ({
            ...prev,
            [itemId]: !currentFollowStatus
        }));

        // ✅ If following a vendor from the suggestions list, remove them from the list
        if (!currentFollowStatus && nonfollowvendorlist && nonfollowvendorlist.length > 0) {
            setNonFollowVendorList(prev =>
                prev.filter(vendor => (vendor.user_id || vendor.id) !== itemId)
            );
        }

        try {
            const response = await axios.post(
                `${BACKEND_URL}website/save-followers`,
                payload
            );

            console.log("save followers api response", response.data);

            // Verify the response indicates success
            if (!response.data || response.data.error) {
                console.error("Backend failed to save follow status");
                // Revert the optimistic update
                setShuffledPosts(shuffledPosts);
                setVendorFollowStatus(prev => ({
                    ...prev,
                    [itemId]: currentFollowStatus
                }));
                // ✅ Restore vendor to list if follow failed
                if (!currentFollowStatus && item) {
                    setNonFollowVendorList(prev => [...prev, item]);
                }
            }
            // ✅ REMOVED: Don't refetch following posts immediately after follow
            // Following posts will only be fetched when:
            // 1. User refreshes the page
            // 2. User navigates away and returns to home
            // 3. User switches to Following tab
        } catch (error) {
            console.error("Follow error:", error);
            // Revert the optimistic update on error
            setShuffledPosts(shuffledPosts);
            setVendorFollowStatus(prev => ({
                ...prev,
                [itemId]: currentFollowStatus
            }));
            // ✅ Restore vendor to list if follow failed
            if (!currentFollowStatus && item) {
                setNonFollowVendorList(prev => [...prev, item]);
            }
        }
    };
    // API FOR POSTS OF FOLLOWING PROFILES
    const fetchgetuserfollowingpost = async (pageNum) => {
        if (loading && pageNum !== 1) return;

        // Get logged-in user ID
        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');

        // If no logged-in user, don't fetch
        if (!loggedInUserId) {
            console.log("❌ No logged-in user found");
            setHasFollowing(false);
            return;
        }

        const payload = {
            login_user_id: loggedInUserId,
            per_page: 10,
            page: pageNum,
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-user-following-post-list`, payload),
                pageNum === 1 ? null : setLoading,
                (data) => {
                    // For first page, set the data. For subsequent pages, append
                    if (pageNum === 1) {
                        // Hide shimmer IMMEDIATELY
                        setIsInitialLoading(false);

                        // Filter posts to ONLY show user_type === "1" (vendors/businesses)
                        const allPosts = data.posts || [];

                        const filteredByUserType = allPosts.filter(post => {
                            const userType = String(post.user_type);
                            const isTypeOne = userType === "1";
                            return isTypeOne;
                        });

                        setFollowingPosts(filteredByUserType);

                        // Check if user has any following
                        const hasAnyFollowing = filteredByUserType.length > 0;
                        setHasFollowing(hasAnyFollowing);
                    } else {
                        // Append new posts to existing ones (filter by user_type 1)
                        const allPosts = data.posts || [];

                        const newFilteredPosts = allPosts.filter(post => {
                            const userType = String(post.user_type);
                            return userType === "1";
                        });
                        setFollowingPosts(prev => {
                            const updated = [...prev, ...newFilteredPosts];
                            console.log("📊 FOLLOWING TAB - Total posts after append:", updated.length);
                            return updated;
                        });
                    }

                    // Check if there's more data
                    const hasMoreData = data.posts && data.posts.length > 0;
                    setHasMore(hasMoreData);
                }
            );

        } catch (error) {
            console.error("❌ FOLLOWING TAB - Error fetching following posts:", error);
            console.error("❌ FOLLOWING TAB - Error details:", error.response?.data || error.message);
            // Hide loading on error for initial load
            if (pageNum === 1) {
                setIsInitialLoading(false);
                setHasFollowing(false);
            }
            setHasMore(false);
        }
    };


    // Add useEffect to reset loading state when switching to Following tab
    useEffect(() => {
        if (activeTab === "following") {
            // If user is not logged in, immediately set loading to false
            if (!isUserLoggedIn()) {
                setIsInitialLoading(false);
                setNonFollowVendorList([]);
            } else {
                // ✅ CHANGED: Only show shimmer if we don't have any following posts yet
                if (followingPosts.length === 0) {
                    setIsInitialLoading(true);
                    fetchgetuserfollowingpost(1);
                }

                // Always fetch vendor suggestions when switching to Following tab
                fetchnonfollowvendorlist();
            }
        }
    }, [activeTab]);
    // API FOR NON FOLLOWER VENDOR LIST
    const fetchnonfollowvendorlist = async () => {
        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');

        if (!loggedInUserId) {
            console.log("❌ No logged-in user found");
            setNonFollowVendorList([]);
            return;
        }

        const payload = {
            login_user_id: loggedInUserId,
            limit: 10,
        };

        try {
            const response = await axios.get(`${BACKEND_URL}website/get-unfollowing-user-list`, {
                params: payload,
            });

            console.log("✅ Non-follow vendor list response:", response.data);

            // ✅ Handle different response structures
            const vendorData = response.data?.data || response.data || [];
            const vendorsArray = Array.isArray(vendorData) ? vendorData : [];

            setNonFollowVendorList(vendorsArray);

            // ✅ Update vendorFollowStatus for these vendors
            const followStatusMap = {};
            vendorsArray.forEach(vendor => {
                const vendorId = vendor.id || vendor.user_id;
                followStatusMap[vendorId] = vendor.is_following || false;
            });
            setVendorFollowStatus(prev => ({
                ...prev,
                ...followStatusMap
            }));

        } catch (error) {
            console.error(
                "❌ NON FOLLOW TAB - Error fetching vendors:",
                error.response?.data || error.message
            );
            setNonFollowVendorList([]);
        }
    };

    useEffect(() => {
        if (activeTab === "following" && isUserLoggedIn()) {
            fetchnonfollowvendorlist();
        }
    }, [activeTab]);

    // API FOR FETCHING THE HOME POST LIST
    const fetchtopcouponofferspost = async (pageNum) => {
        if (loading && pageNum !== 1) return; // Only block if not initial load

        // Get logged-in user ID
        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');

        const payload = {
            login_user_id: loggedInUserId || 501, // Use actual user ID if logged in
            per_page: 10,
            page: pageNum,
        };


        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-post-list`, payload),
                pageNum === 1 ? null : setLoading, // Don't use setLoading for initial load
                (data) => {
                    // For first page, set the data. For subsequent pages, append
                    if (pageNum === 1) {
                        // Hide shimmer IMMEDIATELY - before any data processing
                        setIsInitialLoading(false);

                        // Set all data states immediately for fastest rendering
                        // React 18+ automatically batches these updates
                        setTopcouponpost(data.top_coupon);
                        setGetaways(data.getaways);
                        setPlaceyoumustvisit(data.place_you_must_visit);
                        setYoulovethis(data.love_these);
                        setNormalpost(filterNormalPostsByUserType(data.normal_post));
                        setShortvideo(data.videos_for_you);
                    } else {
                        // Append new posts to existing ones
                        setNormalpost(prev => [...prev, ...filterNormalPostsByUserType(data.normal_post || [])]);

                        // Optionally append to other sections if they have pagination
                        if (data.getaways?.posts) {
                            setGetaways(prev => ({
                                ...prev,
                                posts: [...(prev.posts || []), ...data.getaways.posts]
                            }));
                        }
                        if (data.place_you_must_visit?.posts) {
                            setPlaceyoumustvisit(prev => ({
                                ...prev,
                                posts: [...(prev.posts || []), ...data.place_you_must_visit.posts]
                            }));
                        }
                        if (data.love_these?.posts) {
                            setYoulovethis(prev => ({
                                ...prev,
                                posts: [...(prev.posts || []), ...data.love_these.posts]
                            }));
                        }
                        if (data.videos_for_you?.posts) {
                            setShortvideo(prev => ({
                                ...prev,
                                posts: [...(prev.posts || []), ...data.videos_for_you.posts]
                            }));
                        }
                    }

                    // Check if there's more data
                    const hasMoreData = data.normal_post?.length > 0;
                    setHasMore(hasMoreData);
                }
            );
        } catch (error) {
            console.error("Error fetching Post lists data:", error);
            // Hide loading on error for initial load
            if (pageNum === 1) {
                setIsInitialLoading(false);
            }
            setHasMore(false);
        }
    };

    // Detect page refresh and navigation from other pages
    useEffect(() => {
        // Check if this is a page refresh (not a navigation)
        const navigationEntry = window.performance.getEntriesByType('navigation')[0];
        const navigationType = navigationEntry?.type;

        // Also check performance.navigation for older browsers
        const legacyNavigationType = window.performance.navigation?.type;

        // Type 1 = RELOAD, type 255 = TYPE_RELOAD (in newer API)
        const isRefresh = navigationType === 'reload' ||
            legacyNavigationType === 1 ||
            (navigationEntry && navigationEntry.type === 1);

        if (isRefresh) {
            isPageRefreshRef.current = true;
            // Set flag to trigger shuffle on refresh
            sessionStorage.setItem('navigatedFromNavbarOrLeftSection', 'true');
            sessionStorage.removeItem('returningFromNavigation'); // Clear return flag on refresh
            sessionStorage.removeItem('wasOnOtherPage'); // Clear wasOnOtherPage on refresh
        }
    }, []);

    // Detect navigation to home from other pages
    useEffect(() => {
        // Check if navigating to home from another page (not returning from internal navigation)
        const wasOnOtherPage = sessionStorage.getItem('wasOnOtherPage') === 'true';
        const returningFromNavigation = sessionStorage.getItem('returningFromNavigation') === 'true';

        // If we were on another page and NOT returning from internal navigation, trigger shuffle
        if (wasOnOtherPage && !returningFromNavigation) {
            sessionStorage.setItem('navigatedFromNavbarOrLeftSection', 'true');
            sessionStorage.removeItem('wasOnOtherPage');
        }
    }, []);

    // UPDATED: Initial fetch and page change handler
    useEffect(() => {
        fetchtopcouponofferspost(page);
        // console.log("PAGE=", page);
    }, [page]);

    useEffect(() => {
        // Unified behavior for both mobile and desktop - auto-play when in view
        const videoObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const videoElement = entry.target;
                    const videoIndex = parseInt(videoElement.dataset.videoIndex);

                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        setActiveVideoIndex(videoIndex);

                        // For iOS: Set muted attribute and property before play
                        if (globalMute) {
                            videoElement.setAttribute('muted', 'true');
                            videoElement.muted = true;
                            videoElement.volume = 0;
                        } else {
                            videoElement.removeAttribute('muted');
                            videoElement.muted = false;
                            videoElement.volume = 1;
                        }
                        videoElement.controls = false;
                        videoElement.play().catch(err => {
                            console.log('Play failed:', err);
                        });

                        // Pause all other videos
                        document.querySelectorAll('video[data-video-index]').forEach(otherVideo => {
                            if (otherVideo !== videoElement) {
                                otherVideo.pause();
                            }
                        });
                    } else {
                        videoElement.pause();
                    }
                });
            },
            {
                threshold: 0.5,
                rootMargin: '0px'
            }
        );

        const observeVideos = () => {
            document.querySelectorAll('video[data-video-index]').forEach((video) => {
                videoObserver.observe(video);
            });
        };

        observeVideos();

        const observer = new MutationObserver(observeVideos);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => {
            videoObserver.disconnect();
            observer.disconnect();
        };
    }, [globalMute, shuffledPosts]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setPostpopup(false);
            }
        };

        if (postpopup) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [postpopup]);

    useEffect(() => {
        if (!shuffledPosts || shuffledPosts.length === 0) return;

        const isReturningFromNav = sessionStorage.getItem('returningFromNavigation') === 'true';
        const navigatedFromNavbarOrLeftSection = sessionStorage.getItem('navigatedFromNavbarOrLeftSection') === 'true';
        const isRefresh = isPageRefreshRef.current;

        // If returning from navigation (not from navbar/left section/refresh) or we've already restored, don't recalculate
        if (isReturningFromNav && !navigatedFromNavbarOrLeftSection && !isRefresh) {
            if (hasRestoredSectionsRef.current) {
                return; // Don't recalculate when returning
            }
        }

        setPreCalculatedSections((prev) => {
            const newSections = { ...prev };
            const batchTracking = {};

            // Rebuild batch tracking from previous state
            Object.entries(prev).forEach(([index, section]) => {
                const batch = Math.floor(parseInt(index) / 10);
                if (!batchTracking[batch]) batchTracking[batch] = [];
                batchTracking[batch].push(section.section);
            });

            shuffledPosts.forEach((post, index) => {
                // Skip if section already exists for this index (unless we're shuffling)
                if (newSections[index] && !navigatedFromNavbarOrLeftSection && !isRefresh) return;

                // Show a random block every 5 posts (5th, 10th, 15th…)
                const shouldInsert = (index + 1) % 5 === 0;
                if (!shouldInsert) return;

                const batch = Math.floor(index / 10);
                if (!batchTracking[batch]) batchTracking[batch] = [];

                // List available section types
                const allSections = [];
                if (getaways.posts?.length) allSections.push("getaways");
                if (placeyoumustvisit.posts?.length) allSections.push("placeyoumustvisit");
                if (youlovethis.posts?.length) allSections.push("youlovethis");
                if (shortvideo.posts?.length) allSections.push("shortvideosforyou");

                // Prevent repeat inside the same batch, but allow repeats across batches
                const available = allSections.filter(
                    (s) => !batchTracking[batch].includes(s)
                );

                // If no sections available in this batch, allow all sections (reset for new batch)
                // This ensures special posts continue to show after 15th post
                const sectionsToUse = available.length > 0 ? available : allSections;

                if (sectionsToUse.length === 0) return;

                // Pick one random section
                const selected = sectionsToUse[Math.floor(Math.random() * sectionsToUse.length)];

                batchTracking[batch].push(selected);

                // Store the chosen section + shuffle inner items when navigating from navbar/left section or refresh
                const sectionData = getSectionData(selected);
                // Use shuffled section data if available, otherwise use original
                let dataToUse = sectionData;
                if (selected === "youlovethis" && shuffledYouLoveThis.length > 0) {
                    dataToUse = shuffledYouLoveThis;
                } else if (selected === "placeyoumustvisit" && shuffledPlaceYouMustVisit.length > 0) {
                    dataToUse = shuffledPlaceYouMustVisit;
                } else if (selected === "shortvideosforyou" && shuffledShortVideo.length > 0) {
                    dataToUse = shuffledShortVideo;
                } else if (selected === "getaways" && shuffledGetaways.length > 0) {
                    dataToUse = shuffledGetaways;
                }

                // Shuffle the data if navigating from navbar/left section or refresh
                newSections[index] = {
                    section: selected,
                    data: (navigatedFromNavbarOrLeftSection || isRefresh) ? shuffleArray(dataToUse) : dataToUse
                };
            });

            return newSections;
        });
    }, [
        shuffledPosts,
        getaways.posts,
        placeyoumustvisit.posts,
        youlovethis.posts,
        shortvideo.posts,
        shuffledYouLoveThis,
        shuffledPlaceYouMustVisit,
        shuffledShortVideo,
        shuffledGetaways
    ]);

    // Restore section states and preCalculatedSections early on component mount if returning from navigation
    useEffect(() => {
        const isReturningFromNav = sessionStorage.getItem('returningFromNavigation') === 'true';

        if (isReturningFromNav) {
            // Restore shuffled section arrays
            const savedShuffledYouLoveThis = sessionStorage.getItem('savedShuffledYouLoveThis');
            const savedShuffledPlaceYouMustVisit = sessionStorage.getItem('savedShuffledPlaceYouMustVisit');
            const savedShuffledShortVideo = sessionStorage.getItem('savedShuffledShortVideo');
            const savedShuffledGetaways = sessionStorage.getItem('savedShuffledGetaways');

            if (savedShuffledYouLoveThis) {
                try {
                    setShuffledYouLoveThis(JSON.parse(savedShuffledYouLoveThis));
                } catch (e) {
                    console.error('Error parsing savedShuffledYouLoveThis:', e);
                }
            }
            if (savedShuffledPlaceYouMustVisit) {
                try {
                    setShuffledPlaceYouMustVisit(JSON.parse(savedShuffledPlaceYouMustVisit));
                } catch (e) {
                    console.error('Error parsing savedShuffledPlaceYouMustVisit:', e);
                }
            }
            if (savedShuffledShortVideo) {
                try {
                    setShuffledShortVideo(JSON.parse(savedShuffledShortVideo));
                } catch (e) {
                    console.error('Error parsing savedShuffledShortVideo:', e);
                }
            }
            if (savedShuffledGetaways) {
                try {
                    setShuffledGetaways(JSON.parse(savedShuffledGetaways));
                } catch (e) {
                    console.error('Error parsing savedShuffledGetaways:', e);
                }
            }

            // Restore preCalculatedSections
            const savedPreCalculatedSections = sessionStorage.getItem('savedPreCalculatedSections');
            if (savedPreCalculatedSections) {
                try {
                    const parsed = JSON.parse(savedPreCalculatedSections);
                    setPreCalculatedSections(parsed);
                } catch (e) {
                    console.error('Error parsing savedPreCalculatedSections:', e);
                }
            }

            hasRestoredSectionsRef.current = true; // Mark that we've restored
        }
    }, []); // Run only on mount

    useEffect(() => {
        const navigatedFromNavbarOrLeftSection = sessionStorage.getItem('navigatedFromNavbarOrLeftSection') === 'true';
        const isReturningFromNav = sessionStorage.getItem('returningFromNavigation') === 'true';
        const isRefresh = isPageRefreshRef.current;

        // If returning from navigation (not from navbar/left section/refresh), don't shuffle
        if (isReturningFromNav && !navigatedFromNavbarOrLeftSection && !isRefresh) {
            if (hasRestoredSectionsRef.current) {
                return; // Don't shuffle when returning
            }
        }

        // Check if we have data to shuffle
        const hasData = (youlovethis.posts?.length > 0) ||
            (placeyoumustvisit.posts?.length > 0) ||
            (shortvideo.posts?.length > 0) ||
            (getaways.posts?.length > 0);

        // Shuffle conditions:
        // 1. On page refresh
        // 2. Every 10 post loads (every page change, since each page loads 10 posts)
        // 3. When navigating from navbar or left section
        // Don't shuffle if returning from navigation (unless it's a refresh or navbar navigation)
        const shouldShuffle = (isRefresh || navigatedFromNavbarOrLeftSection || (page > 1 && !isReturningFromNav)) && !loading && hasData;

        if (shouldShuffle) {
            // Shuffle all section posts
            if (youlovethis.posts?.length > 0) {
                setShuffledYouLoveThis(shuffleArray([...youlovethis.posts]));
            }
            if (placeyoumustvisit.posts?.length > 0) {
                setShuffledPlaceYouMustVisit(shuffleArray([...placeyoumustvisit.posts]));
            }
            if (shortvideo.posts?.length > 0) {
                setShuffledShortVideo(shuffleArray([...shortvideo.posts]));
            }
            if (getaways.posts?.length > 0) {
                setShuffledGetaways(shuffleArray([...getaways.posts]));
            }

            // Reset refresh flag after first shuffle
            if (isRefresh && hasData) {
                isPageRefreshRef.current = false;
            }
        } else if (!isReturningFromNav && !hasRestoredSectionsRef.current && !isRefresh && !navigatedFromNavbarOrLeftSection && page === 1) {
            // Initialize without shuffle on first load only (page 1, not refresh, not from navbar)
            if (youlovethis.posts && shuffledYouLoveThis.length === 0) {
                setShuffledYouLoveThis(youlovethis.posts);
            }
            if (placeyoumustvisit.posts && shuffledPlaceYouMustVisit.length === 0) {
                setShuffledPlaceYouMustVisit(placeyoumustvisit.posts);
            }
            if (shortvideo.posts && shuffledShortVideo.length === 0) {
                setShuffledShortVideo(shortvideo.posts);
            }
            if (getaways.posts && shuffledGetaways.length === 0) {
                setShuffledGetaways(getaways.posts);
            }
        }
    }, [page, loading, youlovethis.posts, placeyoumustvisit.posts, shortvideo.posts, getaways.posts]);

    // Save scroll position and section states before navigation
    const saveScrollPosition = (postId = null) => {
        const middleSection = document.querySelector('.middle-section');
        if (middleSection) {
            const scrollTop = middleSection.scrollTop;
            sessionStorage.setItem('homeScrollPosition', scrollTop.toString());
            sessionStorage.setItem('returningFromNavigation', 'true');

            // Save the clicked post ID if provided
            if (postId) {
                sessionStorage.setItem('targetPostId', postId.toString());
                // Initialize restore page to current page
                sessionStorage.setItem('restorePage', page.toString());
            }

            // Save shuffled posts order to prevent reshuffling
            sessionStorage.setItem('savedShuffledPosts', JSON.stringify(shuffledPosts));

            // Save section shuffle states to prevent reshuffling
            sessionStorage.setItem('savedShuffledYouLoveThis', JSON.stringify(shuffledYouLoveThis));
            sessionStorage.setItem('savedShuffledPlaceYouMustVisit', JSON.stringify(shuffledPlaceYouMustVisit));
            sessionStorage.setItem('savedShuffledShortVideo', JSON.stringify(shuffledShortVideo));
            sessionStorage.setItem('savedShuffledGetaways', JSON.stringify(shuffledGetaways));
            sessionStorage.setItem('savedPreCalculatedSections', JSON.stringify(preCalculatedSections));
        }
    };

    // Restore scroll position when returning from navigation
    useEffect(() => {
        const isReturning = sessionStorage.getItem('returningFromNavigation') === 'true';
        const savedScrollPosition = sessionStorage.getItem('homeScrollPosition');
        const targetPostId = sessionStorage.getItem('targetPostId');

        if (isReturning && shuffledPosts.length > 0 && !isRestoringRef.current) {
            // If we have a target post ID, try to scroll to that specific post
            if (targetPostId) {
                const postExists = shuffledPosts.some(post => post.id.toString() === targetPostId);

                if (postExists) {
                    // Post exists, scroll to it
                    isRestoringRef.current = true;
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            const postElement = document.querySelector(`[data-post-id="${targetPostId}"]`);
                            const middleSection = document.querySelector('.middle-section');

                            if (postElement && middleSection) {
                                // Scroll to the post element
                                const elementTop = postElement.offsetTop;
                                middleSection.scrollTop = elementTop - 20; // Small offset for better visibility
                            } else if (middleSection && savedScrollPosition) {
                                // Fallback to saved scroll position if element not found
                                const scrollPosition = parseInt(savedScrollPosition, 10);
                                middleSection.scrollTop = scrollPosition;
                            }

                            // Clear the flag and saved data after restoring
                            setTimeout(() => {
                                sessionStorage.removeItem('returningFromNavigation');
                                sessionStorage.removeItem('targetPostId');
                                sessionStorage.removeItem('homeScrollPosition');
                                sessionStorage.removeItem('restorePage');
                                sessionStorage.removeItem('savedShuffledPosts');
                                sessionStorage.removeItem('savedShuffledYouLoveThis');
                                sessionStorage.removeItem('savedShuffledPlaceYouMustVisit');
                                sessionStorage.removeItem('savedShuffledShortVideo');
                                sessionStorage.removeItem('savedShuffledGetaways');
                                sessionStorage.removeItem('savedPreCalculatedSections');
                                isRestoringRef.current = false;
                            }, 500);
                        }, 150);
                    });
                } else if (hasMore && !loading && !isRestoringRef.current) {
                    // Post doesn't exist yet, load next page
                    // The effect will run again when shuffledPosts updates after loading
                    const savedRestorePage = sessionStorage.getItem('restorePage');
                    const startPage = savedRestorePage ? parseInt(savedRestorePage, 10) : page;
                    const nextPage = startPage + 1;
                    const maxPages = startPage + 10; // Safety limit - load up to 10 more pages from start

                    if (nextPage <= maxPages) {
                        // Prevent multiple simultaneous loads
                        isRestoringRef.current = true;
                        sessionStorage.setItem('restorePage', nextPage.toString());
                        setPage(nextPage);
                        // Reset the flag after loading completes to allow the effect to check again
                        setTimeout(() => {
                            isRestoringRef.current = false;
                        }, 1500);
                    } else if (savedScrollPosition) {
                        // Fallback: use saved scroll position if we can't find the post after max attempts
                        isRestoringRef.current = true;
                        requestAnimationFrame(() => {
                            setTimeout(() => {
                                const middleSection = document.querySelector('.middle-section');
                                if (middleSection) {
                                    const scrollPosition = parseInt(savedScrollPosition, 10);
                                    middleSection.scrollTop = scrollPosition;
                                }
                                setTimeout(() => {
                                    sessionStorage.removeItem('returningFromNavigation');
                                    sessionStorage.removeItem('targetPostId');
                                    sessionStorage.removeItem('homeScrollPosition');
                                    sessionStorage.removeItem('restorePage');
                                    sessionStorage.removeItem('savedShuffledPosts');
                                    sessionStorage.removeItem('savedShuffledYouLoveThis');
                                    sessionStorage.removeItem('savedShuffledPlaceYouMustVisit');
                                    sessionStorage.removeItem('savedShuffledShortVideo');
                                    sessionStorage.removeItem('savedShuffledGetaways');
                                    sessionStorage.removeItem('savedPreCalculatedSections');
                                    isRestoringRef.current = false;
                                }, 500);
                            }, 150);
                        });
                    }
                } else if (savedScrollPosition) {
                    // Fallback: use saved scroll position if we can't load more
                    isRestoringRef.current = true;
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            const middleSection = document.querySelector('.middle-section');
                            if (middleSection) {
                                const scrollPosition = parseInt(savedScrollPosition, 10);
                                middleSection.scrollTop = scrollPosition;
                            }
                            setTimeout(() => {
                                sessionStorage.removeItem('returningFromNavigation');
                                sessionStorage.removeItem('targetPostId');
                                sessionStorage.removeItem('homeScrollPosition');
                                sessionStorage.removeItem('restorePage');
                                sessionStorage.removeItem('savedShuffledPosts');
                                sessionStorage.removeItem('savedShuffledYouLoveThis');
                                sessionStorage.removeItem('savedShuffledPlaceYouMustVisit');
                                sessionStorage.removeItem('savedShuffledShortVideo');
                                sessionStorage.removeItem('savedShuffledGetaways');
                                sessionStorage.removeItem('savedPreCalculatedSections');
                                isRestoringRef.current = false;
                            }, 500);
                        }, 150);
                    });
                }
            } else if (savedScrollPosition) {
                // No target post ID, use saved scroll position
                isRestoringRef.current = true;
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        const middleSection = document.querySelector('.middle-section');
                        if (middleSection) {
                            const scrollPosition = parseInt(savedScrollPosition, 10);
                            middleSection.scrollTop = scrollPosition;
                        }
                        setTimeout(() => {
                            sessionStorage.removeItem('returningFromNavigation');
                            sessionStorage.removeItem('targetPostId');
                            sessionStorage.removeItem('homeScrollPosition');
                            sessionStorage.removeItem('restorePage');
                            sessionStorage.removeItem('savedShuffledPosts');
                            sessionStorage.removeItem('savedShuffledYouLoveThis');
                            sessionStorage.removeItem('savedShuffledPlaceYouMustVisit');
                            sessionStorage.removeItem('savedShuffledShortVideo');
                            sessionStorage.removeItem('savedShuffledGetaways');
                            sessionStorage.removeItem('savedPreCalculatedSections');
                            isRestoringRef.current = false;
                        }, 500);
                    }, 150);
                });
            }
        }
    }, [shuffledPosts.length, page, hasMore, loading]);

    // Shuffle normal posts when navigating from navbar, left section, or on page refresh
    useEffect(() => {
        if (!normalpost || normalpost.length === 0) return;

        // Safety filter: ensure only user_type 1 or 2 posts are included
        const filteredPosts = filterNormalPostsByUserType(normalpost);
        if (filteredPosts.length === 0) return;

        const navigatedFromNavbarOrLeftSection = sessionStorage.getItem('navigatedFromNavbarOrLeftSection') === 'true';
        const isReturningFromNav = sessionStorage.getItem('returningFromNavigation') === 'true';
        const savedShuffledPosts = sessionStorage.getItem('savedShuffledPosts');
        const isRefresh = isPageRefreshRef.current;

        // If returning from navigation (not from navbar/left section/refresh), restore saved order
        if (isReturningFromNav && savedShuffledPosts && !navigatedFromNavbarOrLeftSection && !isRefresh) {
            try {
                const restoredPosts = JSON.parse(savedShuffledPosts);
                // Create a map of post IDs for quick lookup
                const filteredPostsMap = new Map(filteredPosts.map(post => [post.id, post]));

                // Restore order by matching IDs, and update with latest data
                const restoredOrder = restoredPosts
                    .map(savedPost => {
                        const updatedPost = filteredPostsMap.get(savedPost.id);
                        return updatedPost || null; // Use updated post data if available
                    })
                    .filter(post => post !== null); // Remove posts that no longer exist

                // Add any new posts that weren't in the saved list (pagination)
                const restoredIds = new Set(restoredOrder.map(p => p.id));
                const newPosts = filteredPosts.filter(post => !restoredIds.has(post.id));

                setShuffledPosts([...restoredOrder, ...newPosts]);
                return;
            } catch (e) {
                console.error('Error parsing savedShuffledPosts:', e);
                // Fall through to normal logic if parsing fails
            }
        }

        // Shuffle if navigating from navbar, left section, or on page refresh
        if (navigatedFromNavbarOrLeftSection || isRefresh) {
            // Shuffle all posts (both recent and old)
            const shuffled = shuffleArray([...filteredPosts]);
            setShuffledPosts(shuffled);

            // Clear the flag after shuffling
            if (navigatedFromNavbarOrLeftSection) {
                sessionStorage.removeItem('navigatedFromNavbarOrLeftSection');
            }
            // Reset refresh flag after first shuffle
            if (isRefresh) {
                isPageRefreshRef.current = false;
            }
            return;
        }

        // Default: no shuffle, just set posts in original order
        if (shuffledPosts.length === 0) {
            setShuffledPosts(filteredPosts);
        } else if (!isReturningFromNav && !navigatedFromNavbarOrLeftSection && !isRefresh) {
            // Append new posts from pagination (when normalpost grows)
            // Only add posts that don't already exist in shuffledPosts
            const existingIds = new Set(shuffledPosts.map(p => p.id));
            const newPosts = filteredPosts.filter(post => !existingIds.has(post.id));
            if (newPosts.length > 0) {
                setShuffledPosts(prev => [...prev, ...newPosts]);
            }
        }
    }, [normalpost]);


    //Download POP UP IMAGE LOADS INSTANLY
    useEffect(() => {
        const img = new Image();
        img.src = popup_yatch;
    }, []);

    // Vendor list search functions
    const fetchHomeVendorList = async (searchValue = "") => {
        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');

        if (!loggedInUserId) {
            console.log("❌ No logged-in user, skipping vendor follow status fetch");
            return;
        }

        const payload = {
            login_user_id: loggedInUserId,
            search_text: ""
        };
        setIsHomeSearchLoading(true);
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-vendor-list`, payload);
            const data = response.data?.data || response.data || [];
            const vendorsArray = Array.isArray(data) ? data : [];

            if (vendorsArray.length > allHomeVendors.length || allHomeVendors.length === 0) {
                setAllHomeVendors(vendorsArray);
            }

            // ✅ NEW: Store follow status by user_id
            const followStatusMap = {};
            vendorsArray.forEach(vendor => {
                const vendorId = vendor.id || vendor.user_id;
                followStatusMap[vendorId] = vendor.is_following;
            });
            setVendorFollowStatus(followStatusMap);

            const filteredVendors = filterHomeVendorsBySearch(vendorsArray, searchValue);
            setHomeVendorList(filteredVendors);
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            setHomeVendorList([]);
        } finally {
            setIsHomeSearchLoading(false);
        }
    }
    // Helper function to get search position score (lower score = higher priority)
    const getSearchPositionScore = (text, searchTerm) => {
        if (!text || !searchTerm) return Infinity;
        const textLower = text.toLowerCase();
        const searchLower = searchTerm.toLowerCase().trim();
        const position = textLower.indexOf(searchLower);

        if (position === -1) return Infinity; // Not found

        // Lower position = higher priority
        // Position 0 (starts with) = highest priority
        return position;
    };

    const filterHomeVendorsBySearch = (vendors, searchValue) => {
        if (!searchValue || searchValue.trim() === "") {
            return vendors;
        }

        const searchLower = searchValue.toLowerCase().trim();
        const filtered = vendors.filter((vendor) => {
            const vendorName = (vendor.vendor_name || vendor.user_name || vendor.name || "").toLowerCase();
            const businessType = (vendor.type_of_business || vendor.business_type || "").toLowerCase();
            const city = (vendor.city || "").toLowerCase();

            return (
                vendorName.includes(searchLower) ||
                businessType.includes(searchLower) ||
                city.includes(searchLower)
            );
        });

        // Sort by search term position (earlier position = higher priority)
        return filtered.sort((a, b) => {
            const aName = (a.vendor_name || a.user_name || a.name || "").toLowerCase();
            const bName = (b.vendor_name || b.user_name || b.name || "").toLowerCase();
            const aBusinessType = (a.type_of_business || a.business_type || "").toLowerCase();
            const bBusinessType = (b.type_of_business || b.business_type || "").toLowerCase();
            const aCity = (a.city || "").toLowerCase();
            const bCity = (b.city || "").toLowerCase();

            // Get the best (lowest) position score for each vendor
            const aScore = Math.min(
                getSearchPositionScore(aName, searchLower),
                getSearchPositionScore(aBusinessType, searchLower),
                getSearchPositionScore(aCity, searchLower)
            );
            const bScore = Math.min(
                getSearchPositionScore(bName, searchLower),
                getSearchPositionScore(bBusinessType, searchLower),
                getSearchPositionScore(bCity, searchLower)
            );

            return aScore - bScore; // Lower score comes first
        });
    }

    // Fetch coupons from search-post-list API
    const fetchHomeSearchCoupons = async (searchValue = "") => {
        if (!searchValue || searchValue.trim().length === 0) {
            setHomeSearchCoupons([]);
            return;
        }

        // IMPORTANT: Backend API only searches by user_name, not coupon_title
        // So we call API WITHOUT search term to get ALL coupons, then filter client-side
        setIsHomeCouponsLoading(true);
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.517725,
            longitude: longitude || 54.363599,
            search: "", // Empty search to get all coupons - we'll filter client-side
        };

        try {
            const response = await axios.post(`${BACKEND_URL}website/search-post-list`, payload);
            const data = response?.data || {};

            // Extract coupon_list from response
            let coupons = [];

            if (Array.isArray(data)) {
                // If it's an array, filter for coupons
                coupons = data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
            } else {
                // Handle object response
                if (data.coupon_list) {
                    coupons = Array.isArray(data.coupon_list) ? data.coupon_list : [];
                } else if (data.offers) {
                    coupons = Array.isArray(data.offers) ? data.offers : [];
                } else if (data.coupons) {
                    coupons = Array.isArray(data.coupons) ? data.coupons : [];
                }
            }

            // CLIENT-SIDE FILTERING: Filter coupons based on BOTH coupon_title AND user_name
            // This allows searching by coupon_title (which backend doesn't support)
            const searchLower = searchValue.toLowerCase().trim();
            const filteredCoupons = coupons.filter((coupon) => {
                const couponTitle = String(coupon.coupon_title || "").toLowerCase().trim();
                const userName = String(coupon.user_name || "").toLowerCase().trim();

                // Check if search term appears in coupon_title OR user_name (letter-by-letter matching)
                // This allows matching "buy" in "Buy 1 Get 1 Free" or "bu" in user names
                const titleMatch = couponTitle.includes(searchLower);
                const nameMatch = userName.includes(searchLower);

                return titleMatch || nameMatch;
            });

            // Sort coupons by search term position in coupon_title (earlier position = higher priority)
            // Prioritize coupon_title over user_name for sorting
            const sortedCoupons = filteredCoupons.sort((a, b) => {
                const aTitle = (a.coupon_title || "").toLowerCase();
                const bTitle = (b.coupon_title || "").toLowerCase();
                const aName = (a.user_name || "").toLowerCase();
                const bName = (b.user_name || "").toLowerCase();

                // Get position score for coupon_title (primary) and user_name (fallback)
                const aTitleScore = getSearchPositionScore(aTitle, searchLower);
                const bTitleScore = getSearchPositionScore(bTitle, searchLower);
                const aNameScore = getSearchPositionScore(aName, searchLower);
                const bNameScore = getSearchPositionScore(bName, searchLower);

                // Prioritize coupon_title: if both have title match, compare by title position
                // If one has title match and other doesn't, title match wins
                // If neither has title match, compare by user_name
                const aScore = aTitleScore !== Infinity ? aTitleScore : (aNameScore !== Infinity ? aNameScore + 1000 : Infinity);
                const bScore = bTitleScore !== Infinity ? bTitleScore : (bNameScore !== Infinity ? bNameScore + 1000 : Infinity);

                return aScore - bScore; // Lower score comes first
            });

            setHomeSearchCoupons(sortedCoupons);
        } catch (error) {
            console.error("Error fetching search coupons:", error);
            setHomeSearchCoupons([]);
        } finally {
            setIsHomeCouponsLoading(false);
        }
    }

    // Fetch events from get-event-list API
    const fetchHomeSearchEvents = async (searchValue = "") => {
        // IMPORTANT: Backend API may not search by title, so we call API to get ALL events, then filter client-side
        setIsHomeEventsLoading(true);
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.517725,
            longitude: longitude || 54.363599,
            state_id: "",
            user_id: "",
        };

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-list`, payload);
            const data = response?.data || [];
            const eventsArray = Array.isArray(data) ? data : [];

            // Always store all events (for client-side filtering)
            if (eventsArray.length > allHomeEvents.length || allHomeEvents.length === 0) {
                setAllHomeEvents(eventsArray);
            }

            // If no search value, clear search events
            if (!searchValue || searchValue.trim().length === 0) {
                setHomeSearchEvents([]);
                return;
            }

            // CLIENT-SIDE FILTERING: Filter events based on title
            const searchLower = searchValue.toLowerCase().trim();
            const filteredEvents = eventsArray.filter((event) => {
                const eventTitle = String(event.title || "").toLowerCase().trim();
                return eventTitle.includes(searchLower);
            });

            // Sort events by search term position in title (earlier position = higher priority)
            const sortedEvents = filteredEvents.sort((a, b) => {
                const aTitle = (a.title || "").toLowerCase();
                const bTitle = (b.title || "").toLowerCase();

                const aScore = getSearchPositionScore(aTitle, searchLower);
                const bScore = getSearchPositionScore(bTitle, searchLower);

                return aScore - bScore; // Lower score comes first
            });

            setHomeSearchEvents(sortedEvents);
        } catch (error) {
            console.error("Error fetching event list:", error);
            setHomeSearchEvents([]);
        } finally {
            setIsHomeEventsLoading(false);
        }
    }
    const handleHomeSearchChange = (e) => {
        const value = e.target.value;
        setHomeSearchText(value);

        // Show dropdown immediately if there's text
        if (value.trim().length > 0) {
            setShowHomeDropdown(true);
            setIsHomeSearchLoading(true); // 🔹 set loading immediately (vendors)
            // Reset coupons/events loading; they will be set by their own fetch functions
            setIsHomeCouponsLoading(true);
            setIsHomeEventsLoading(true);
        } else {
            setShowHomeDropdown(false);
            setIsHomeSearchLoading(false);
            setIsHomeCouponsLoading(false);
            setIsHomeEventsLoading(false);
            setHomeVendorList(allHomeVendors || []);
            setHomeSearchCoupons([]);
            setHomeSearchEvents([]);
            return;
        }

        // Immediate client-side vendor filtering for instant feedback
        if (allHomeVendors.length > 0) {
            const filtered = filterHomeVendorsBySearch(allHomeVendors, value);
            setHomeVendorList(filtered);
        }

        // Immediate client-side event filtering
        if (allHomeEvents.length > 0) {
            const searchLower = value.toLowerCase().trim();
            const filteredEvents = allHomeEvents.filter((event) =>
                (event.title || "").toLowerCase().includes(searchLower)
            );
            setHomeSearchEvents(filteredEvents);
        }

        // Debounce API calls
        if (homeSearchDebounceTimerRef.current) {
            clearTimeout(homeSearchDebounceTimerRef.current);
        }

        homeSearchDebounceTimerRef.current = setTimeout(() => {
            // API calls
            fetchHomeVendorList(value);
            fetchHomeSearchCoupons(value);
            fetchHomeSearchEvents(value);
        }, 300);
    };

    const handleHomeVendorSelect = (vendor) => {
        const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "";
        setHomeSearchText(vendorName);
        setShowHomeDropdown(false);
    };

    const handleHomeSearchEnter = (e) => {
        if (e.key === "Enter" && homeSearchText.trim().length > 0) {
            // Navigate to search page with search query
            navigate(`/searchpage?search=${encodeURIComponent(homeSearchText.trim())}`);
        }
    };

    const handleHomeClearSearch = () => {
        setHomeSearchText("");
        setShowHomeDropdown(false);
        setIsHomeSearchLoading(false);
        setIsHomeCouponsLoading(false);
        setIsHomeEventsLoading(false);
        setHomeSearchCoupons([]);
        setHomeSearchEvents([]);
        if (allHomeVendors.length > 0) {
            setHomeVendorList(allHomeVendors);
        } else {
            fetchHomeVendorList("");
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                homeDropdownRef.current &&
                homeSearchBoxRef.current &&
                !homeDropdownRef.current.contains(event.target) &&
                !homeSearchBoxRef.current.contains(event.target)
            ) {
                setShowHomeDropdown(false);
            }
        };

        if (showHomeDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showHomeDropdown]);

    // Initial fetch on component mount
    useEffect(() => {
        fetchHomeVendorList();
        // Fetch all events on mount for client-side filtering
        fetchHomeSearchEvents("");

        return () => {
            if (homeSearchDebounceTimerRef.current) {
                clearTimeout(homeSearchDebounceTimerRef.current);
            }
        };
    }, []);

    // Location is now managed globally by LocationContext - no need for local geolocation

    // Fetch brand list for trending section (same payload structure as BusinessBrands)
    const fetchTrendingBrands = useCallback(async () => {
        // Wait for coordinates to be set and location to finish loading
        if (!latitude || !longitude || isLocationLoading) {
            return;
        }

        const lat = parseFloat(latitude || 24.4539);
        const lng = parseFloat(longitude || 54.3773);
        const coordKey = `${lat.toFixed(4)}_${lng.toFixed(4)}`;

        // Prevent multiple simultaneous calls
        if (isFetchingTrendingBrandsRef.current) {
            return;
        }

        // Don't refetch if we already fetched for these coordinates
        if (lastFetchedCoordsRef.current === coordKey) {
            return;
        }

        isFetchingTrendingBrandsRef.current = true;

        const payload = {
            latitude: lat,
            longitude: lng,
            state_id: emirate?.id || "", // Same pattern as other pages: emirate?.id || ""
            page: 1,
            per_page: 50, // Fetch more to have enough for shuffling
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-brand-list`, payload),
                null, // No loading state for this one
                (data) => {
                    // Handle different response structures (same as BusinessBrands)
                    const brandData = data?.data || data || [];

                    if (brandData.length > 0) {
                        // Shuffle the array and select 7 items
                        const shuffled = shuffleArray([...brandData]);
                        const selected = shuffled.slice(0, 7);
                        setTrendingBrands(selected);
                        // setVendorList(shuffled)
                        lastFetchedCoordsRef.current = coordKey; // Store the coordinates we fetched for
                    }
                }
            );
        } catch (error) {
            // Only log non-rate-limit errors to avoid console spam
            if (error.response?.status !== 429) {
                console.error("Error fetching trending brands:", error);
            }
            // Silently handle rate limiting (429) - this is expected if called too frequently
        } finally {
            isFetchingTrendingBrandsRef.current = false;
        }
    }, [latitude, longitude, emirate, isLocationLoading, hasRealLocation, selectedState]);

    // Fetch trending brands when coordinates are available (same pattern as BusinessBrands)
    // Only fetch when coordinates change and location is loaded
    useEffect(() => {
        if (latitude && longitude && !isLocationLoading) {
            // Call when location is ready - fetchTrendingBrands already has guards against duplicate calls
            fetchTrendingBrands();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latitude, longitude, isLocationLoading]); // Depend on coordinates and loading state

    // Re-check overflow when text is collapsed (after clicking "Less")
    useEffect(() => {
        shuffledPosts.forEach((item) => {
            if (item.id && !expand[item.id]) {
                const textElement = document.querySelector(`[data-caption-id="${item.id}"]`);
                if (textElement) {
                    setTimeout(() => {
                        const isOverflowing = textElement.scrollHeight > textElement.clientHeight;
                        setTextOverflow(prev => {
                            if (prev[item.id] !== isOverflowing) {
                                return {
                                    ...prev,
                                    [item.id]: isOverflowing
                                };
                            }
                            return prev;
                        });
                    }, 100);
                }
            }
        });
    }, [expand, shuffledPosts]);


    useEffect(() => {
        // Function to scroll to top
        const scrollToTop = () => {
            const middleSection = document.querySelector('.middle-section');
            if (middleSection) {
                middleSection.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        };

        // Add event listener to home icon
        const homeIcon = document.querySelector('.homepage-icons a[href="/"]');
        if (homeIcon) {
            homeIcon.addEventListener('click', scrollToTop);
        }

        // Cleanup
        return () => {
            if (homeIcon) {
                homeIcon.removeEventListener('click', scrollToTop);
            }
        };
    }, [])
    return (
        <div>
            <Navbar />
            <div className="main-layout">
                <LeftSection />
                <main className="middle-section" ref={middleSectionRef}>
                    <div className="mobile-search-container home-page-container">
                        <div className="mobile-searchbox-forhome home-page" ref={homeSearchBoxRef}>
                            <img src={search} alt="search" />
                            <input
                                type="text"
                                placeholder="Search..."
                                value={homeSearchText}
                                onChange={handleHomeSearchChange}
                                onKeyDown={handleHomeSearchEnter}
                                onFocus={() => {
                                    if (homeSearchText.trim().length > 0 && (homeVendorList.length > 0 || homeSearchCoupons.length > 0 || homeSearchEvents.length > 0)) {
                                        setShowHomeDropdown(true);
                                    }
                                }}
                            />
                            {homeSearchText && homeSearchText.trim().length > 0 && (
                                <img
                                    src={xmark}
                                    alt="clear"
                                    className="home-search-clear-icon"
                                    onClick={handleHomeClearSearch}
                                    style={{ cursor: "pointer", display: "block" }}
                                />
                            )}
                        </div>

                        {/* Search results dropdown - shows vendors (View Profile) and coupons (Offer) */}
                        {showHomeDropdown && homeSearchText.trim().length > 0 && (
                            <div className="home-vendor-list-container" ref={homeDropdownRef}>
                                {isHomeSearchLoading ? (
                                    <div className="home-vendor-list-loading">Loading...</div>
                                ) : (
                                    <>
                                        {/* Display Vendors from get-vendor-list API */}
                                        {homeVendorList.length > 0 && homeVendorList.map((vendor, index) => {
                                            const vendorId = vendor.user_id || vendor.vendor_id || vendor.id;
                                            const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "Unknown Vendor";
                                            const vendorImage = vendor.user_image || vendor.vendor_cover_image || vendor.profile_image || "";
                                            const userType = String(vendor.user_type || vendor.userType || "");
                                            const isUserTypeZero = userType === "0";

                                            return (
                                                <div
                                                    key={vendorId || index}
                                                    className="home-vendor-list-item"
                                                    onClick={() => {
                                                        handleHomeVendorSelect(vendor);
                                                        navigate(`/searchpage/${vendorId}?search=${encodeURIComponent(vendorName)}`);
                                                    }}
                                                >
                                                    <div className="home-vendor-list-content">
                                                        {vendorImage && vendorImage.trim() !== '' ? (
                                                            <img
                                                                src={vendorImage}
                                                                alt={vendorName}
                                                                className={`home-vendor-list-image ${isUserTypeZero ? 'home-vendor-list-image-circle' : 'home-vendor-list-image-square'}`}
                                                            />
                                                        ) : (
                                                            <div className={`home-vendor-list-initial ${isUserTypeZero ? 'home-vendor-list-initial-circle' : 'home-vendor-list-initial-square'}`}>
                                                                {vendorName ? vendorName.charAt(0).toUpperCase() : '?'}
                                                            </div>
                                                        )}
                                                        <span className="home-vendor-list-name">{vendorName}</span>
                                                    </div>
                                                    <Link
                                                        to={isUserTypeZero ? `/userprofile/${vendorId}` : `/vendordetails/${vendorId}`}
                                                        className="home-vendor-view-profile-btn remove-underline"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleHomeVendorSelect(vendor);
                                                        }}
                                                    >
                                                        View Profile
                                                    </Link>
                                                </div>
                                            );
                                        })}

                                        {/* Display Coupons (Offers) from search-post-list API */}
                                        {homeSearchCoupons.length > 0 && homeSearchCoupons.map((coupon, index) => {
                                            const couponId = coupon.coupon_id;
                                            // const userId = coupon.user_id;
                                            const userName = coupon.coupon_title || "Unknown offer name";
                                            const userImage = coupon.coupon_image || "";
                                            const categoryId = coupon.category?.[0]?.category || 0;

                                            return (
                                                <div
                                                    key={`coupon-${couponId || index}`}
                                                    className="home-vendor-list-item"
                                                    onClick={() => {
                                                        navigate(`/offers/${couponId}/${categoryId}`);
                                                        setShowHomeDropdown(false);
                                                        setHomeSearchText("");
                                                    }}
                                                >
                                                    <div className="home-vendor-list-content">
                                                        {userImage && userImage.trim() !== '' ? (
                                                            <img
                                                                src={userImage}
                                                                alt={userName}
                                                                className="home-vendor-list-image home-vendor-list-image-square"
                                                            />
                                                        ) : (
                                                            <div className="home-vendor-list-initial home-vendor-list-initial-square">
                                                                {userName ? userName.charAt(0).toUpperCase() : '?'}
                                                            </div>
                                                        )}
                                                        <span className="home-vendor-list-name">{userName}</span>
                                                    </div>
                                                    <span className="home-vendor-offer-text">Offer</span>
                                                </div>
                                            );
                                        })}

                                        {/* Display Events from get-event-list API */}
                                        {homeSearchEvents.length > 0 && homeSearchEvents.map((event, index) => {
                                            const eventId = event.event_id;
                                            const eventTitle = event.title || "Unknown event";
                                            const eventImage = event.event_image || "";

                                            return (
                                                <div
                                                    key={`event-${eventId || index}`}
                                                    className="home-vendor-list-item"
                                                    onClick={() => {
                                                        navigate(`/eventdetails/${eventId}`);
                                                        setShowHomeDropdown(false);
                                                        setHomeSearchText("");
                                                    }}
                                                >
                                                    <div className="home-vendor-list-content">
                                                        {eventImage && eventImage.trim() !== '' ? (
                                                            <img
                                                                src={eventImage}
                                                                alt={eventTitle}
                                                                className="home-vendor-list-image home-vendor-list-image-square"
                                                            />
                                                        ) : (
                                                            <div className="home-vendor-list-initial home-vendor-list-initial-square">
                                                                {eventTitle ? eventTitle.charAt(0).toUpperCase() : '?'}
                                                            </div>
                                                        )}
                                                        <span className="home-vendor-list-name">{eventTitle}</span>
                                                    </div>
                                                    <span className="home-vendor-offer-text">Event</span>
                                                </div>
                                            );
                                        })}

                                        {/* Only show 'No results' if ALL search calls finished (vendors + coupons + events) */}
                                        {homeVendorList.length === 0 &&
                                            homeSearchCoupons.length === 0 &&
                                            homeSearchEvents.length === 0 &&
                                            !isHomeSearchLoading &&
                                            !isHomeCouponsLoading &&
                                            !isHomeEventsLoading && (
                                                <div className="home-vendor-list-loading">No results found</div>
                                            )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="carousel-Img topcoupon-carousel">
                        {isInitialLoading ? (
                            <div className="shimmer-topcoupon-container">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div key={`shimmer-topcoupon-${index}`} className="shimmer-topcoupon-card">
                                        <div className="shimmer-topcoupon-image"></div>
                                        <div className="shimmer-topcoupon-vendor">
                                            <div className="shimmer-topcoupon-vendor-img"></div>
                                            <div className="shimmer-topcoupon-vendor-name"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Slider {...topcouponsettings}>
                                {topcouponpost.posts &&
                                    topcouponpost.posts.length > 0 &&
                                    topcouponpost.posts.map((item, index) => (
                                        <Link
                                            to={`/offers/${item.coupon_id}/0`}
                                            className="remove-underline"
                                            key={index}
                                            onClick={saveScrollPosition}
                                        >
                                            <div className="coupon-card">
                                                <img
                                                    className="carousel_Images"
                                                    src={item.coupon_image || PLACEHOLDER_IMAGE}
                                                    alt={item.user_name}
                                                    onError={(e) => {
                                                        e.target.src = PLACEHOLDER_IMAGE
                                                    }}
                                                />

                                                <div className="home-carousel-vendor">
                                                    <img
                                                        src={item.user_image}
                                                        alt={item.user_name}
                                                        className="home-carousel-vendor-img"
                                                    />
                                                    <p className="home-carousel-vendor-name">
                                                        {item.user_name}
                                                    </p>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                            </Slider>
                        )}
                    </div>

                    <div className="ai-mobile-image">
                        <img src={AiMobileImage} alt="ai-mobile-img" />
                    </div>


                    <div className="border-for-midsection">
                        {/* <div className="tabs">
                            <button>Discover</button>
                            <button>Following</button>
                            <button>Connections</button>
                        </div> */}

                        {/* Tab Buttons */}
                        {/* <div className="tabs">
                            <button
                                className={activeTab === "discover" ? "tab active" : "tab"}
                                onClick={() => setActiveTab("discover")}
                            >
                                Discover
                            </button>

                            <button
                                className={activeTab === "following" ? "tab active" : "tab"}
                                onClick={() => setActiveTab("following")}
                            >
                                Following
                            </button>

                            <button
                                className={activeTab === "connections" ? "tab active" : "tab"}
                                onClick={() => setActiveTab("connections")}
                            >
                                Connections
                            </button>
                        </div> */}

                        {/* Active Tab Content Discover*/}

                        {activeTab === "discover" &&
                            <>
                                {isInitialLoading ? (
                                    // Shimmer loading skeleton for feed posts
                                    Array.from({ length: 5 }).map((_, index) => (
                                        <div key={`shimmer-post-${index}`} className="feed-card shimmer-feed-card">
                                            <div className="feed-header">
                                                <div className="profile-info">
                                                    <div className="shimmer-profile-img"></div>
                                                    <div className="hotelname">
                                                        <div className="shimmer-username"></div>
                                                        <div className="shimmer-location"></div>
                                                    </div>
                                                </div>
                                                <div className="header-actions">
                                                    <div className="shimmer-follow-btn"></div>
                                                    <div className="shimmer-more-icon"></div>
                                                </div>
                                            </div>
                                            <div className="shimmer-feed-image"></div>
                                            <div className="post-content-text">
                                                <div className="feed-actions">
                                                    <div className="left-icons">
                                                        <div className="shimmer-action-icon"></div>
                                                        <div className="shimmer-action-icon"></div>
                                                        <div className="shimmer-action-icon"></div>
                                                    </div>
                                                    <div className="shimmer-save-icon"></div>
                                                </div>
                                                <div className="feed-caption">
                                                    <div className="shimmer-caption-line"></div>
                                                    <div className="shimmer-caption-line shimmer-caption-line-partial"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    shuffledPosts.map((item, index) => {
                                        const sectionObj = preCalculatedSections?.[index] || null;
                                        const sectionName = sectionObj?.section;
                                        const sectionData = sectionObj?.data || [];
                                        const isLastPost = shuffledPosts.length === index + 1;

                                        // Check if this is a review-style post (user_type === "0" and view_type === 11 or 12)
                                        const isReviewPost = String(item.user_type) === "0" && (item.view_type === 11 || item.view_type === 12);
                                        const isReviewWithImage = String(item.user_type) === "0" && item.view_type === 12;
                                        // Check if this is a background image post (user_type === "0" and view_type === 13)
                                        const isBackgroundImagePost = String(item.user_type) === "0" && item.view_type === 13;

                                        return (
                                            <React.Fragment key={item.id}>
                                                {/* Review-style post or Normal post */}
                                                <div className={`feed-card ${isReviewPost ? 'review-card' : ''}`} data-post-id={item.id} ref={isLastPost ? lastPostRef : null}>
                                                    <div className="feed-header">
                                                        <div className="profile-info">
                                                            <Link
                                                                to={String(item.user_type) === "0" ? `/userprofile/${item.user_id}` : `/vendordetails/${item.user_id}`}
                                                                className="remove-underline"
                                                                onClick={saveScrollPosition}
                                                            >
                                                                {item.user_image && item.user_image.trim() !== '' ? (
                                                                    <img src={item.user_image} alt="feedcard1" />
                                                                ) : (
                                                                    <div className="profile-initial">
                                                                        {item.user_name ? item.user_name.charAt(0).toUpperCase() : '?'}
                                                                    </div>
                                                                )}
                                                            </Link>

                                                            <div className="hotelname">
                                                                <div className="business-name-and-category-name">
                                                                    {String(item.user_type) === "0" ? (
                                                                        /* For user_type "0": username has no navigation, recommend_user has navigation */
                                                                        <>
                                                                            <Link to={`/userprofile/${item.user_id}`} className="remove-underline">
                                                                                <h4>{item.user_name}</h4>
                                                                            </Link>
                                                                            {(item.view_type === 11 || item.view_type === 12) && (
                                                                                <>
                                                                                    {/* For user_type "0", show only one: category_name OR recommend_user (not both) */}
                                                                                    {item.category_name && item.category_name.trim() !== '' ? (
                                                                                        <span className="looking-for">
                                                                                            looking for <strong>{item.category_name}</strong>
                                                                                        </span>
                                                                                    ) : item.recommend_user && item.recommend_user.user_name && item.recommend_user.user_name.trim() !== '' ? (
                                                                                        <span className="recommend-text">
                                                                                            recommend
                                                                                            <Link
                                                                                                to={`/vendordetails/${item.recommend_user.user_id || item.recommend_user.id}`}
                                                                                                className="remove-underline"
                                                                                                onClick={saveScrollPosition}
                                                                                            >
                                                                                                <strong>{item.recommend_user.user_name}</strong>
                                                                                            </Link>
                                                                                        </span>
                                                                                    ) : null}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        /* For other user_types: everything wrapped in Link */
                                                                        <Link
                                                                            to={`/vendordetails/${item.user_id}`}
                                                                            className="remove-underline"
                                                                            onClick={saveScrollPosition}
                                                                        >
                                                                            <h4>{item.user_name}</h4>
                                                                            {(item.view_type === 11 || item.view_type === 12) && (
                                                                                <>
                                                                                    {/* For other user_types, show both if they exist */}
                                                                                    {item.category_name && item.category_name.trim() !== '' && (
                                                                                        <span className="looking-for">
                                                                                            looking for <strong>{item.category_name}</strong>
                                                                                        </span>
                                                                                    )}
                                                                                    {item.recommend_user && item.recommend_user.user_name && item.recommend_user.user_name.trim() !== '' && (
                                                                                        <span className="recommend-text">
                                                                                            recommend <strong>{item.recommend_user.user_name}</strong>
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </Link>
                                                                    )}
                                                                </div>
                                                                <p>
                                                                    {String(item.user_type) === "0" && item.post_location
                                                                        ? item.post_location
                                                                        : item.state
                                                                    }
                                                                </p>
                                                                {/* | {item.following} Followers */}
                                                            </div>
                                                        </div>

                                                        <div className="header-actions">
                                                            {String(item.user_type) !== "0" && (
                                                                <p
                                                                    className="tag1"
                                                                    onClick={() => savefollower(item)}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        color: item.is_following ? "#606060" : "#1877f2" // blue for Follow
                                                                    }}
                                                                >
                                                                    {item.is_following ? "Following" : "Follow"}
                                                                </p>
                                                            )}

                                                            <div className="more-icon-container">
                                                                <img
                                                                    src={threedot}
                                                                    alt="threedot"
                                                                    // onClick={toggleRotanaPopup}
                                                                    onClick={() => setDownloadPopupOpen(true)}
                                                                />
                                                                {/* {showPopupRotana && (
                                                        <div className="popup-menu">
                                                            <p>Report</p>
                                                        </div>
                                                    )} */}
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {/* Review-style content for user_type === "0" and view_type === 11 or 12 */}
                                                    {isReviewPost ? (
                                                        <div className="review-content">
                                                            {isReviewWithImage ? (
                                                                /* view_type === 12: Show description on top, then image */
                                                                <>
                                                                    {item.description && item.description.trim() !== '' && (() => {
                                                                        // Mobile vs desktop limits
                                                                        // const descLimit = isMobile ? 60 : 100;
                                                                        const descTruncateLength = isMobile ? 130 : 220;
                                                                        const shouldTruncate = item.description.length > descTruncateLength;
                                                                        const isExpanded = reviewExpand[item.id];

                                                                        return (
                                                                            <div className="review-description">
                                                                                <p className="review-text">
                                                                                    {isExpanded
                                                                                        ? item.description
                                                                                        : shouldTruncate
                                                                                            ? `${item.description.substring(0, descTruncateLength)}...`
                                                                                            : item.description
                                                                                    }

                                                                                    {shouldTruncate && (
                                                                                        <span
                                                                                            className="review-text-toggle"
                                                                                            onClick={() =>
                                                                                                setReviewExpand(prev => ({
                                                                                                    ...prev,
                                                                                                    [item.id]: !prev[item.id]
                                                                                                }))
                                                                                            }
                                                                                        >
                                                                                            {isExpanded ? "Less" : "More"}
                                                                                        </span>
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                        );
                                                                    })()}

                                                                    <div className="review-image">
                                                                        {item.post_images && (item.post_images.length > 0 && item.post_images[0].post_images) ? (
                                                                            <ReviewImageSlider
                                                                                post={item}
                                                                                activeSlide={activeSlide}
                                                                                sliderSettings={sliderSettings}
                                                                                coupons={item.coupons || []}
                                                                                categoryId={item.category_id}
                                                                            />
                                                                        ) : item.primary_image ? (
                                                                            <div style={{ position: 'relative', width: '100%' }}>
                                                                                <img
                                                                                    src={item.primary_image}
                                                                                    alt={`Post ${item.id}`}
                                                                                    className="review-image-content"
                                                                                    style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                                                                                />
                                                                                {item.coupons && item.coupons.length > 0 && (
                                                                                    <div className="review-post-coupon-overlay-container">
                                                                                        {item.coupons.map((coupon, couponIdx) => (
                                                                                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={item.category_id} />
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                /* view_type === 11: Show description */
                                                                <>
                                                                    <div className={`review-description ${isArabic(item.description) ? 'arabic-text' : ''}`}>
                                                                        {(item.description || translatedTexts[item.id]) && (() => {
                                                                            const textToShow =
                                                                                isTranslated[item.id] && translatedTexts[item.id]
                                                                                    ? translatedTexts[item.id]
                                                                                    : item.description;

                                                                            // const descLimit = isMobile ? 50 : 100;
                                                                            const descTruncateLength = isMobile ? 120 : 210;
                                                                            const shouldTruncate = textToShow.length > descTruncateLength;
                                                                            const isExpanded = reviewExpand[item.id];

                                                                            return (
                                                                                <>
                                                                                    <p
                                                                                        className="review-text"
                                                                                        dir={isArabic(item.description) && !isTranslated[item.id] ? "rtl" : "ltr"}
                                                                                    >
                                                                                        {isExpanded
                                                                                            ? textToShow
                                                                                            : shouldTruncate
                                                                                                ? `${textToShow.substring(0, descTruncateLength)}...`
                                                                                                : textToShow
                                                                                        }

                                                                                        {shouldTruncate && (
                                                                                            <span
                                                                                                className="review-text-toggle"
                                                                                                onClick={() =>
                                                                                                    setReviewExpand(prev => ({
                                                                                                        ...prev,
                                                                                                        [item.id]: !prev[item.id]
                                                                                                    }))
                                                                                                }
                                                                                            >
                                                                                                {isExpanded ? "Less" : "More"}
                                                                                            </span>
                                                                                        )}
                                                                                    </p>

                                                                                    {/* Translation toggle */}
                                                                                    {isArabic(item.description) && (
                                                                                        <div className="review-translation-toggle">
                                                                                            {!isTranslated[item.id] && (
                                                                                                <>
                                                                                                    {isTranslating[item.id] ? (
                                                                                                        <span className="translation-loading">Translating...</span>
                                                                                                    ) : (
                                                                                                        <span
                                                                                                            className="translation-link"
                                                                                                            onClick={async () => {
                                                                                                                if (!translatedTexts[item.id]) {
                                                                                                                    setIsTranslating(prev => ({ ...prev, [item.id]: true }));
                                                                                                                    try {
                                                                                                                        const translated = await translateText(item.description, 'en');
                                                                                                                        if (translated && translated.trim()) {
                                                                                                                            setTranslatedTexts(prev => ({ ...prev, [item.id]: translated }));
                                                                                                                            setIsTranslated(prev => ({ ...prev, [item.id]: true }));
                                                                                                                        } else {
                                                                                                                            alert("Translation failed.");
                                                                                                                        }
                                                                                                                    } catch (err) {
                                                                                                                        console.error(err);
                                                                                                                        alert("Translation failed.");
                                                                                                                    } finally {
                                                                                                                        setIsTranslating(prev => ({ ...prev, [item.id]: false }));
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    setIsTranslated(prev => ({ ...prev, [item.id]: true }));
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            See Translation
                                                                                                        </span>
                                                                                                    )}
                                                                                                </>
                                                                                            )}

                                                                                            {isTranslated[item.id] && translatedTexts[item.id] && (
                                                                                                <span
                                                                                                    className="translation-link translation-link-original"
                                                                                                    onClick={() =>
                                                                                                        setIsTranslated(prev => ({ ...prev, [item.id]: false }))
                                                                                                    }
                                                                                                >
                                                                                                    See Original
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        })()}
                                                                    </div>

                                                                    {/* Coupons below description */}
                                                                    {item.coupons && item.coupons.length > 0 && (
                                                                        <div className="review-post-coupon-cards-container">
                                                                            {item.coupons.map((coupon, couponIdx) => (
                                                                                <CouponCard key={couponIdx} coupon={coupon} isOverlay={false} categoryId={item.category_id} />
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>

                                                    ) : null}

                                                    {/* Background image post for user_type === "0" and view_type === 13 */}
                                                    {isBackgroundImagePost ? (
                                                        <div
                                                            className="background-image-post"
                                                            style={{
                                                                backgroundImage: item.background_image ? `url(${item.background_image})` : 'none',
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat',
                                                                minHeight: '400px',
                                                                position: 'relative',
                                                                width: '100%',
                                                                aspectRatio: '1 / 1',
                                                                overflow: 'hidden'
                                                            }}
                                                        >
                                                            {(item.description || item.background_image_title) && (
                                                                <div
                                                                    className="background-image-content"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform: 'translate(-50%, -50%)',
                                                                        color: item.background_image_title_color || 'black',
                                                                        textAlign: 'center',
                                                                        padding: '20px',
                                                                        zIndex: 2,
                                                                        width: '90%',
                                                                        maxWidth: '100%'
                                                                    }}
                                                                >
                                                                    {item.background_image_title && (
                                                                        <h3 style={{
                                                                            margin: '0 0 10px 0',
                                                                            color: item.background_image_title_color || 'black',
                                                                            fontSize: '24px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                            {item.background_image_title}
                                                                        </h3>
                                                                    )}
                                                                    {item.description && (
                                                                        <p style={{
                                                                            margin: 0,
                                                                            color: item.background_image_title_color || 'black',
                                                                            fontSize: '18px',
                                                                            fontWeight: '500',
                                                                            wordWrap: 'break-word'
                                                                        }}>
                                                                            {item.description}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : null}


                                                    {/* Only show media for non-review posts */}
                                                    {!isReviewPost && !isBackgroundImagePost && (
                                                        <FeedMediaContent
                                                            post={item}
                                                            index={index}
                                                            activeSlide={activeSlide}
                                                            sliderSettings={sliderSettings}
                                                            initializeVideo={initializeVideo}
                                                            globalMute={globalMute}
                                                            toggleMute={toggleMute}
                                                            videomute={videomute}
                                                            videounmute={videounmute}
                                                            getActionTypeColor={getActionTypeColor}
                                                            saveScrollPosition={saveScrollPosition}
                                                        />
                                                    )}

                                                    <div className="post-content-text">
                                                        <div className="feed-actions">
                                                            <div className="left-icons">
                                                                <img src={hearticon} alt="heart icon" className="heart" onClick={() => setDownloadPopupOpen(true)} /><span>{item.likes > 0 ? item.likes : ''}</span>
                                                                <p className="post-vertical-line">|</p>
                                                                <img
                                                                    src={commenticon}
                                                                    alt="comment icon"
                                                                    className="comment"
                                                                    onClick={() => {
                                                                        if (isUserLoggedIn()) {
                                                                            // Toggle comment box for this post
                                                                            setShowCommentBox(prev => ({
                                                                                ...prev,
                                                                                [item.id]: !prev[item.id]
                                                                            }));
                                                                        } else {
                                                                            // Show download popup for non-logged-in users
                                                                            setDownloadPopupOpen(true);
                                                                        }
                                                                    }}
                                                                /><span>{item.comments_count > 0 ? item.comments_count : ''}</span>
                                                                <p className="post-vertical-line">|</p>
                                                                <img src={shareicon} alt="share icon" className="shareicon" onClick={() => setDownloadPopupOpen(true)} /><span></span>
                                                            </div>
                                                            <img src={save} alt="save" id="save" onClick={() => setDownloadPopupOpen(true)} />
                                                        </div>


                                                        {/* Show description for non-review posts, or timestamp for review posts */}
                                                        {isReviewPost ? (
                                                            <div className="review-timestamp">

                                                            </div>
                                                        ) : !isBackgroundImagePost ? (
                                                            <div className="feed-caption">
                                                                {item.description && (() => {
                                                                    // const descLimit = 60; // adjust as needed for mobile/desktop
                                                                    const descTruncateLength = 180;
                                                                    const shouldTruncate = item.description.length > descTruncateLength;
                                                                    const isExpanded = expand[item.id];

                                                                    return (
                                                                        <p className={`feed-caption-text ${isExpanded ? "expanded" : ""}`}>
                                                                            {isExpanded
                                                                                ? item.description
                                                                                : shouldTruncate
                                                                                    ? `${item.description.substring(0, descTruncateLength)}... `
                                                                                    : item.description
                                                                            }

                                                                            {shouldTruncate && (
                                                                                <span
                                                                                    className="feed-caption-toggle"
                                                                                    onClick={() =>
                                                                                        setExpand(prev => ({
                                                                                            ...prev,
                                                                                            [item.id]: !prev[item.id]
                                                                                        }))
                                                                                    }
                                                                                >
                                                                                    {isExpanded ? "Less" : "More"}
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    );
                                                                })()}
                                                            </div>

                                                        ) : null}

                                                        {/* Comment box - only show for logged-in users */}
                                                        {isUserLoggedIn() && showCommentBox[item.id] && (
                                                            <div className="home-post-comment-input">
                                                                <p>comments</p>
                                                                <div className="home-comment-input-wrapper">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Share your thoughts..."
                                                                        autoFocus
                                                                    />
                                                                    <div className="home-comment-icons">
                                                                        <img src={linkicon} alt="link icon" />
                                                                        <img src={emoji} alt="emoji icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>

                                                </div>

                                                {/* Insert random section */}
                                                {sectionName === "youlovethis" && sectionData.length > 0 && (
                                                    <div className="youlovethis-grid-container">
                                                        <div className="youlovethis-grid-header">
                                                            <h4>{youlovethis.section_title}</h4>
                                                            {/* Show circle arrows only if more than 2 cards on website view, hide on mobile */}
                                                            {sectionData.length > 2 && !isMobileView && (
                                                                <div className="circlearrows youlovethis">
                                                                    <img
                                                                        src={circleleftarrow}
                                                                        alt="circleleft"
                                                                        onClick={() => {
                                                                            const sliderKey = `youlovethis-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickPrev();
                                                                            }
                                                                        }}

                                                                    />
                                                                    <img
                                                                        src={circlerightarrow}
                                                                        alt="circleright"
                                                                        onClick={() => {
                                                                            const sliderKey = `youlovethis-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickNext();
                                                                            }
                                                                        }}

                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="youlovethis-grid-wrapper youlovethis-slider-wrapper">
                                                            <Slider ref={(slider) => {
                                                                const sliderKey = `youlovethis-${index}`;
                                                                if (slider) {
                                                                    sliderRefs.current[sliderKey] = slider;
                                                                } else {
                                                                    delete sliderRefs.current[sliderKey];
                                                                }
                                                            }} {...getYoulovethisSliderSettings(sectionData.length)}>
                                                                {sectionData.map((sitem) => (
                                                                    <div key={sitem.coupon_id}>
                                                                        <Link
                                                                            to={`/offers/${sitem.coupon_id}/${sitem.category_id}`}
                                                                            className="remove-underline"
                                                                            onClick={saveScrollPosition}
                                                                        >
                                                                            <div className="youlovethis-grid-card">
                                                                                <img
                                                                                    src={sitem.image || PLACEHOLDER_IMAGE}
                                                                                    alt={sitem.title}
                                                                                    className="youlovethis-grid-img"
                                                                                    onError={(e) => {
                                                                                        e.target.src = PLACEHOLDER_IMAGE
                                                                                    }}
                                                                                />
                                                                                <div className="youlovethis-grid-content">
                                                                                    <h4>{sitem.title}</h4>
                                                                                    <p>{sitem.subtitle}</p>
                                                                                </div>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                ))}
                                                            </Slider>
                                                        </div>
                                                    </div>
                                                )}

                                                {sectionName === "placeyoumustvisit" && sectionData.length > 0 && (
                                                    <div className="double-carousel-container placeyouvisit-container">
                                                        <div id="offer-text">
                                                            <h4>{placeyoumustvisit.section_title}</h4>
                                                            {sectionData.length > 2 && !isMobileView && (
                                                                <div className="circlearrows youlovethis">
                                                                    <img
                                                                        src={circleleftarrow}
                                                                        alt="circleleft"
                                                                        onClick={() => {
                                                                            const sliderKey = `placeyoumustvisit-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickPrev();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <img
                                                                        src={circlerightarrow}
                                                                        alt="circleright"
                                                                        onClick={() => {
                                                                            const sliderKey = `placeyoumustvisit-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickNext();
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        <Slider ref={(slider) => {
                                                            const sliderKey = `placeyoumustvisit-${index}`;
                                                            if (slider) {
                                                                sliderRefs.current[sliderKey] = slider;
                                                            } else {
                                                                delete sliderRefs.current[sliderKey];
                                                            }
                                                        }} {...getPlacedeatils(sectionData.length)}>
                                                            {sectionData.map((sitem, sidx) => {
                                                                // ✅ NEW: Get follow status from vendorFollowStatus map
                                                                const userId = sitem.user_id;
                                                                const isFollowing = vendorFollowStatus[userId] || false;

                                                                return (
                                                                    <Link
                                                                        to={`/vendordetails/${userId}`}
                                                                        className="remove-underline"
                                                                        key={userId}
                                                                        onClick={saveScrollPosition}
                                                                    >
                                                                        <div className="carousel-card placeyoumustvisit-card">
                                                                            <div className="image-container">
                                                                                <img
                                                                                    src={sitem.image || PLACEHOLDER_IMAGE}
                                                                                    className="main-img"
                                                                                    alt=""
                                                                                    onError={(e) => {
                                                                                        e.target.src = PLACEHOLDER_IMAGE
                                                                                    }}
                                                                                />
                                                                                <img
                                                                                    src={sitem.user_image || PLACEHOLDER_IMAGE}
                                                                                    className="small-img"
                                                                                    alt=""
                                                                                    onError={(e) => {
                                                                                        e.target.src = PLACEHOLDER_IMAGE
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                            <div className="card-content">
                                                                                <h4>{sitem.user_name}</h4>

                                                                                <div className="follow-offer">
                                                                                    <button
                                                                                        className={`follow-button ${isFollowing ? 'following' : ''}`}
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();

                                                                                            // ✅ NEW: Check login status
                                                                                            if (!isUserLoggedIn()) {
                                                                                                setDownloadPopupOpen(true);
                                                                                                return;
                                                                                            }

                                                                                            // ✅ NEW: Call savefollower with the item data
                                                                                            savefollower(sitem);
                                                                                        }}

                                                                                        style={{
                                                                                            backgroundColor: isFollowing ? "#DBE8FF" : "#1877f2",
                                                                                            color: isFollowing ? "#031955" : "#fff"
                                                                                        }}
                                                                                    >
                                                                                        {isFollowing ? "Following" : "Follow"}
                                                                                    </button>
                                                                                    <button
                                                                                        className="offer-button"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            navigate(`/vendordetails/${userId}?tab=Offers`);
                                                                                        }}
                                                                                    >
                                                                                        See offers
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                );
                                                            })}
                                                        </Slider>
                                                    </div>
                                                )}

                                                {sectionName === "shortvideosforyou" && sectionData.length > 0 && (
                                                    <div className="double-carousel-container shortvideo">
                                                        <div id="offer-text">
                                                            <h4>{shortvideo.section_title}</h4>
                                                            {/* Show circle arrows only if more than 2 cards on website view, hide on mobile */}
                                                            {sectionData.length > 2 && !isMobileView && (
                                                                <div className="circlearrows videosforyou">
                                                                    <img
                                                                        src={circleleftarrow}
                                                                        alt="circleleft"
                                                                        onClick={() => {
                                                                            const sliderKey = `shortvideosforyou-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickPrev();
                                                                            }
                                                                        }}

                                                                    />
                                                                    <img
                                                                        src={circlerightarrow}
                                                                        alt="circleright"
                                                                        onClick={() => {
                                                                            const sliderKey = `shortvideosforyou-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickNext();
                                                                            }
                                                                        }}

                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        <Slider ref={(slider) => {
                                                            const sliderKey = `shortvideosforyou-${index}`;
                                                            if (slider) {
                                                                sliderRefs.current[sliderKey] = slider;
                                                            } else {
                                                                delete sliderRefs.current[sliderKey];
                                                            }
                                                        }} {...getPlacedeatils(sectionData.length)}>
                                                            {sectionData.map((sitem, sidx) => (
                                                                <div className="" key={sidx}>
                                                                    <div className="short-video">
                                                                        <Link
                                                                            to="/videoposts"
                                                                            state={{ postData: sitem, postIndex: index }}
                                                                            onClick={() => {
                                                                                sessionStorage.setItem('videopost_navigated', 'true');
                                                                                sessionStorage.setItem('fetch_all_videos', 'true'); // Fetch all videos when navigating from shortvideosforyou section
                                                                                if (sitem?.id) saveScrollPosition(sitem.id);
                                                                            }}
                                                                        >
                                                                            <video
                                                                                ref={(el) => {
                                                                                    if (el) {
                                                                                        initializeShortVideo(el, sitem.video_file);
                                                                                        // Set webkit-playsinline for older iOS versions
                                                                                        el.setAttribute('webkit-playsinline', 'true');
                                                                                        el.controls = false;
                                                                                    }
                                                                                }}
                                                                                poster={sitem.video_cover_picture}
                                                                                autoPlay
                                                                                muted
                                                                                loop
                                                                                playsInline
                                                                                controls={false}
                                                                            />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                    </div>
                                                )}

                                                {sectionName === "getaways" && sectionData.length > 0 && (
                                                    <div className="double-carousel-container getaway-staycations">
                                                        <div id="offer-text">
                                                            <h4>{getaways.section_title}</h4>
                                                            {/* Show circle arrows only if more than 2 cards on website view, hide on mobile */}
                                                            {sectionData.length > 2 && !isMobileView && (
                                                                <div className="circlearrows getaway">
                                                                    <img
                                                                        src={circleleftarrow}
                                                                        alt="circleleft"
                                                                        onClick={() => {
                                                                            const sliderKey = `getaways-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickPrev();
                                                                            }
                                                                        }}

                                                                    />
                                                                    <img
                                                                        src={circlerightarrow}
                                                                        alt="circleright"
                                                                        onClick={() => {
                                                                            const sliderKey = `getaways-${index}`;
                                                                            if (sliderRefs.current[sliderKey]) {
                                                                                sliderRefs.current[sliderKey].slickNext();
                                                                            }
                                                                        }}

                                                                    />
                                                                </div>
                                                            )}
                                                        </div>

                                                        <Slider ref={(slider) => {
                                                            const sliderKey = `getaways-${index}`;
                                                            if (slider) {
                                                                sliderRefs.current[sliderKey] = slider;
                                                            } else {
                                                                delete sliderRefs.current[sliderKey];
                                                            }
                                                        }} {...getPlacedeatils(sectionData.length)}>
                                                            {sectionData.map((sitem) => (
                                                                <Link
                                                                    to={`/offers/${sitem.coupon_id}/${sitem.category_id}`}
                                                                    className="remove-underline"
                                                                    key={sitem.coupon_id}
                                                                    onClick={saveScrollPosition}
                                                                >
                                                                    <div className="carousel-card getaway-staycations">
                                                                        <div
                                                                            className="background-image"
                                                                            style={{ backgroundImage: `url(${sitem.image})` }}
                                                                        >
                                                                            <div className="overlay-content">
                                                                                <h4>{sitem.title}</h4>
                                                                                <p>{sitem.subtitle}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            ))}
                                                        </Slider>
                                                    </div>
                                                )}

                                                {loading && (index + 1) % 10 === 0 && (
                                                    <div className="loading-container">
                                                        <div className="loader-spinner"></div>
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        );
                                    })
                                )}

                                {/* NEW: End of feed message */}
                                {!hasMore && !loading && shuffledPosts.length > 0 && !isInitialLoading && (
                                    <div className="end-of-feed">
                                        You've reached the end of your feed
                                    </div>
                                )}
                            </>
                        }

                        {/* Tab Content Following */}

                        {activeTab === "following" && (
                            <>
                                {!isUserLoggedIn() ? (
                                    // Show message for non-logged-in users
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        marginTop: "40px"
                                    }} className="no-follow-connect-div">
                                        <img
                                            src={no_follow_connect}
                                            alt="no-follow-image"
                                            style={{
                                                height: "75px",
                                                width: "135px",
                                                objectFit: "contain"
                                            }}
                                            className="no-follow-connect-image"
                                        />
                                        <p style={{
                                            fontFamily: "Roboto-Regular",
                                            fontSize: "15px",
                                            color: "#989898",
                                            textAlign: "center",
                                            padding: "0 20px"
                                        }}>
                                            Explore and follow businesses to personalize your feed
                                        </p>
                                    </div>
                                ) : isInitialLoading ? (
                                    // Shimmer loading skeleton for following posts
                                    Array.from({ length: 5 }).map((_, index) => (
                                        <div key={`shimmer-following-${index}`} className="feed-card shimmer-feed-card">
                                            <div className="feed-header">
                                                <div className="profile-info">
                                                    <div className="shimmer-profile-img"></div>
                                                    <div className="hotelname">
                                                        <div className="shimmer-username"></div>
                                                        <div className="shimmer-location"></div>
                                                    </div>
                                                </div>
                                                <div className="header-actions">
                                                    <div className="shimmer-follow-btn"></div>
                                                    <div className="shimmer-more-icon"></div>
                                                </div>
                                            </div>
                                            <div className="shimmer-feed-image"></div>
                                            <div className="post-content-text">
                                                <div className="feed-actions">
                                                    <div className="left-icons">
                                                        <div className="shimmer-action-icon"></div>
                                                        <div className="shimmer-action-icon"></div>
                                                        <div className="shimmer-action-icon"></div>
                                                    </div>
                                                    <div className="shimmer-save-icon"></div>
                                                </div>
                                                <div className="feed-caption">
                                                    <div className="shimmer-caption-line"></div>
                                                    <div className="shimmer-caption-line shimmer-caption-line-partial"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : !hasFollowing && followingPosts.length === 0 && nonfollowvendorlist && nonfollowvendorlist.length > 0 ? (
                                    <>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginTop: "40px"
                                        }} className="no-follow-connect-div">
                                            <img
                                                src={no_follow_connect}
                                                alt="no-follow-image"
                                                style={{
                                                    height: "75px",
                                                    width: "135px",
                                                    objectFit: "contain"
                                                }}
                                                className="no-follow-connect-image"
                                            />
                                            <p style={{
                                                fontFamily: "Roboto-Regular",
                                                fontSize: "15px",
                                                color: "#989898",
                                                textAlign: "center",
                                                padding: "0 20px"
                                            }}>
                                                Explore and follow businesses to personalize your feed
                                            </p>
                                        </div>

                                        <div className="following-suggestions-section">

                                            {nonfollowvendorlist.map((vendor, index) => {
                                                const vendorId = vendor.user_id || vendor.id;
                                                const vendorImage = vendor.user_image || vendor.profile_image || vendor.cover_image;
                                                const vendorName = vendor.user_name || vendor.vendor_name || vendor.name;

                                                // ✅ Check vendorFollowStatus first, then fallback to vendor.is_following
                                                const isFollowing = vendorFollowStatus[vendorId] !== undefined
                                                    ? vendorFollowStatus[vendorId]
                                                    : (vendor.is_following || false);

                                                return (
                                                    <div className="trend-card" key={vendorId || index}>
                                                        <Link
                                                            to={`/vendordetails/${vendorId}`}
                                                            className="remove-underline"
                                                            onClick={saveScrollPosition}
                                                        >
                                                            {vendorImage ? (
                                                                <img
                                                                    src={vendorImage}
                                                                    alt={vendorName}
                                                                    onError={(e) => {
                                                                        e.target.src = PLACEHOLDER_IMAGE;
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div className="vendor-initial">
                                                                    {vendorName ? vendorName.charAt(0).toUpperCase() : '?'}
                                                                </div>
                                                            )}
                                                        </Link>
                                                        <div className="trend-info">
                                                            <Link
                                                                to={`/vendordetails/${vendorId}`}
                                                                className="remove-underline"
                                                                onClick={saveScrollPosition}
                                                            >
                                                                <h4>{vendorName}</h4>
                                                            </Link>
                                                        </div>
                                                        <div className="follow-rating">
                                                            <button
                                                                className="follow-btn home-right-section"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    savefollower(vendor);
                                                                }}
                                                                style={{
                                                                    backgroundColor: isFollowing ? "#DBE8FF" : "#1877f2",
                                                                    color: isFollowing ? "#031955" : "#fff"
                                                                }}
                                                            >
                                                                {isFollowing ? "Following" : "Follow"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            <p style={{
                                                color: "#d9d9d9",
                                                fontSize: "12px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                marginBottom: "50px"
                                            }}
                                                onClick={() => navigate("/business-and-brands")}
                                            >See All</p>
                                        </div>
                                    </>
                                ) : (
                                    // Show following posts
                                    <>
                                        {followingPosts.map((item, index) => {
                                            const isLastPost = followingPosts.length === index + 1;
                                            const isReviewPost = String(item.user_type) === "0" && (item.view_type === 11 || item.view_type === 12);
                                            const isReviewWithImage = String(item.user_type) === "0" && item.view_type === 12;
                                            const isBackgroundImagePost = String(item.user_type) === "0" && item.view_type === 13;

                                            return (
                                                <React.Fragment key={item.id}>
                                                    {/* Same feed card structure as Discover tab */}
                                                    <div className={`feed-card ${isReviewPost ? 'review-card' : ''}`} data-post-id={item.id} ref={isLastPost ? lastPostRef : null}>
                                                        <div className="feed-header">
                                                            <div className="profile-info">
                                                                <Link
                                                                    to={String(item.user_type) === "0" ? `/userprofile/${item.user_id}` : `/vendordetails/${item.user_id}`}
                                                                    className="remove-underline"
                                                                    onClick={saveScrollPosition}
                                                                >
                                                                    {item.user_image && item.user_image.trim() !== '' ? (
                                                                        <img src={item.user_image} alt="feedcard1" />
                                                                    ) : (
                                                                        <div className="profile-initial">
                                                                            {item.user_name ? item.user_name.charAt(0).toUpperCase() : '?'}
                                                                        </div>
                                                                    )}
                                                                </Link>

                                                                <div className="hotelname">
                                                                    <div className="business-name-and-category-name">
                                                                        {String(item.user_type) === "0" ? (
                                                                            <>
                                                                                <Link to={`/userprofile/${item.user_id}`} className="remove-underline">
                                                                                    <h4>{item.user_name}</h4>
                                                                                </Link>
                                                                                {(item.view_type === 11 || item.view_type === 12) && (
                                                                                    <>
                                                                                        {item.category_name && item.category_name.trim() !== '' ? (
                                                                                            <span className="looking-for">
                                                                                                looking for <strong>{item.category_name}</strong>
                                                                                            </span>
                                                                                        ) : item.recommend_user && item.recommend_user.user_name && item.recommend_user.user_name.trim() !== '' ? (
                                                                                            <span className="recommend-text">
                                                                                                recommend
                                                                                                <Link
                                                                                                    to={`/vendordetails/${item.recommend_user.user_id || item.recommend_user.id}`}
                                                                                                    className="remove-underline"
                                                                                                    onClick={saveScrollPosition}
                                                                                                >
                                                                                                    <strong>{item.recommend_user.user_name}</strong>
                                                                                                </Link>
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <Link
                                                                                to={`/vendordetails/${item.user_id}`}
                                                                                className="remove-underline"
                                                                                onClick={saveScrollPosition}
                                                                            >
                                                                                <h4>{item.user_name}</h4>
                                                                                {(item.view_type === 11 || item.view_type === 12) && (
                                                                                    <>
                                                                                        {item.category_name && item.category_name.trim() !== '' && (
                                                                                            <span className="looking-for">
                                                                                                looking for <strong>{item.category_name}</strong>
                                                                                            </span>
                                                                                        )}
                                                                                        {item.recommend_user && item.recommend_user.user_name && item.recommend_user.user_name.trim() !== '' && (
                                                                                            <span className="recommend-text">
                                                                                                recommend <strong>{item.recommend_user.user_name}</strong>
                                                                                            </span>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </Link>
                                                                        )}
                                                                    </div>
                                                                    <p>
                                                                        {String(item.user_type) === "0" && item.post_location
                                                                            ? item.post_location
                                                                            : item.state
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="header-actions">
                                                                {String(item.user_type) !== "0" && (
                                                                    <p
                                                                        className="tag1"
                                                                        onClick={() => savefollower(item)}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            color: item.is_following ? "#606060" : "#1877f2"
                                                                        }}
                                                                    >
                                                                        {item.is_following ? "Following" : "Follow"}
                                                                    </p>
                                                                )}

                                                                <div className="more-icon-container">
                                                                    <img
                                                                        src={threedot}
                                                                        alt="threedot"
                                                                        onClick={() => setDownloadPopupOpen(true)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Review-style content */}
                                                        {isReviewPost ? (
                                                            <div className="review-content">
                                                                {isReviewWithImage ? (
                                                                    <>
                                                                        {item.description && item.description.trim() !== '' && (() => {
                                                                            const descTruncateLength = isMobile ? 130 : 220;
                                                                            const shouldTruncate = item.description.length > descTruncateLength;
                                                                            const isExpanded = reviewExpand[item.id];

                                                                            return (
                                                                                <div className="review-description">
                                                                                    <p className="review-text">
                                                                                        {isExpanded
                                                                                            ? item.description
                                                                                            : shouldTruncate
                                                                                                ? `${item.description.substring(0, descTruncateLength)}...`
                                                                                                : item.description
                                                                                        }

                                                                                        {shouldTruncate && (
                                                                                            <span
                                                                                                className="review-text-toggle"
                                                                                                onClick={() =>
                                                                                                    setReviewExpand(prev => ({
                                                                                                        ...prev,
                                                                                                        [item.id]: !prev[item.id]
                                                                                                    }))
                                                                                                }
                                                                                            >
                                                                                                {isExpanded ? "Less" : "More"}
                                                                                            </span>
                                                                                        )}
                                                                                    </p>
                                                                                </div>
                                                                            );
                                                                        })()}

                                                                        <div className="review-image">
                                                                            {item.post_images && (item.post_images.length > 0 && item.post_images[0].post_images) ? (
                                                                                <ReviewImageSlider
                                                                                    post={item}
                                                                                    activeSlide={activeSlide}
                                                                                    sliderSettings={sliderSettings}
                                                                                    coupons={item.coupons || []}
                                                                                    categoryId={item.category_id}
                                                                                />
                                                                            ) : item.primary_image ? (
                                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                                    <img
                                                                                        src={item.primary_image}
                                                                                        alt={`Post ${item.id}`}
                                                                                        className="review-image-content"
                                                                                        style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                                                                                    />
                                                                                    {item.coupons && item.coupons.length > 0 && (
                                                                                        <div className="review-post-coupon-overlay-container">
                                                                                            {item.coupons.map((coupon, couponIdx) => (
                                                                                                <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={item.category_id} />
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ) : null}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className={`review-description ${isArabic(item.description) ? 'arabic-text' : ''}`}>
                                                                            {(item.description || translatedTexts[item.id]) && (() => {
                                                                                const textToShow =
                                                                                    isTranslated[item.id] && translatedTexts[item.id]
                                                                                        ? translatedTexts[item.id]
                                                                                        : item.description;

                                                                                const descTruncateLength = isMobile ? 120 : 210;
                                                                                const shouldTruncate = textToShow.length > descTruncateLength;
                                                                                const isExpanded = reviewExpand[item.id];

                                                                                return (
                                                                                    <>
                                                                                        <p
                                                                                            className="review-text"
                                                                                            dir={isArabic(item.description) && !isTranslated[item.id] ? "rtl" : "ltr"}
                                                                                        >
                                                                                            {isExpanded
                                                                                                ? textToShow
                                                                                                : shouldTruncate
                                                                                                    ? `${textToShow.substring(0, descTruncateLength)}...`
                                                                                                    : textToShow
                                                                                            }

                                                                                            {shouldTruncate && (
                                                                                                <span
                                                                                                    className="review-text-toggle"
                                                                                                    onClick={() =>
                                                                                                        setReviewExpand(prev => ({
                                                                                                            ...prev,
                                                                                                            [item.id]: !prev[item.id]
                                                                                                        }))
                                                                                                    }
                                                                                                >
                                                                                                    {isExpanded ? "Less" : "More"}
                                                                                                </span>
                                                                                            )}
                                                                                        </p>

                                                                                        {isArabic(item.description) && (
                                                                                            <div className="review-translation-toggle">
                                                                                                {!isTranslated[item.id] && (
                                                                                                    <>
                                                                                                        {isTranslating[item.id] ? (
                                                                                                            <span className="translation-loading">Translating...</span>
                                                                                                        ) : (
                                                                                                            <span
                                                                                                                className="translation-link"
                                                                                                                onClick={async () => {
                                                                                                                    if (!translatedTexts[item.id]) {
                                                                                                                        setIsTranslating(prev => ({ ...prev, [item.id]: true }));
                                                                                                                        try {
                                                                                                                            const translated = await translateText(item.description, 'en');
                                                                                                                            if (translated && translated.trim()) {
                                                                                                                                setTranslatedTexts(prev => ({ ...prev, [item.id]: translated }));
                                                                                                                                setIsTranslated(prev => ({ ...prev, [item.id]: true }));
                                                                                                                            } else {
                                                                                                                                alert("Translation failed.");
                                                                                                                            }
                                                                                                                        } catch (err) {
                                                                                                                            console.error(err);
                                                                                                                            alert("Translation failed.");
                                                                                                                        } finally {
                                                                                                                            setIsTranslating(prev => ({ ...prev, [item.id]: false }));
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        setIsTranslated(prev => ({ ...prev, [item.id]: true }));
                                                                                                                    }
                                                                                                                }}
                                                                                                            >
                                                                                                                See Translation
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}

                                                                                                {isTranslated[item.id] && translatedTexts[item.id] && (
                                                                                                    <span
                                                                                                        className="translation-link translation-link-original"
                                                                                                        onClick={() =>
                                                                                                            setIsTranslated(prev => ({ ...prev, [item.id]: false }))
                                                                                                        }
                                                                                                    >
                                                                                                        See Original
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })()}
                                                                        </div>

                                                                        {item.coupons && item.coupons.length > 0 && (
                                                                            <div className="review-post-coupon-cards-container">
                                                                                {item.coupons.map((coupon, couponIdx) => (
                                                                                    <CouponCard key={couponIdx} coupon={coupon} isOverlay={false} categoryId={item.category_id} />
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        ) : null}

                                                        {/* Background image post */}
                                                        {isBackgroundImagePost ? (
                                                            <div
                                                                className="background-image-post"
                                                                style={{
                                                                    backgroundImage: item.background_image ? `url(${item.background_image})` : 'none',
                                                                    backgroundSize: 'cover',
                                                                    backgroundPosition: 'center',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    minHeight: '400px',
                                                                    position: 'relative',
                                                                    width: '100%',
                                                                    aspectRatio: '1 / 1',
                                                                    overflow: 'hidden'
                                                                }}
                                                            >
                                                                {(item.description || item.background_image_title) && (
                                                                    <div
                                                                        className="background-image-content"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            color: item.background_image_title_color || 'black',
                                                                            textAlign: 'center',
                                                                            padding: '20px',
                                                                            zIndex: 2,
                                                                            width: '90%',
                                                                            maxWidth: '100%'
                                                                        }}
                                                                    >
                                                                        {item.background_image_title && (
                                                                            <h3 style={{
                                                                                margin: '0 0 10px 0',
                                                                                color: item.background_image_title_color || 'black',
                                                                                fontSize: '24px',
                                                                                fontWeight: 'bold'
                                                                            }}>
                                                                                {item.background_image_title}
                                                                            </h3>
                                                                        )}
                                                                        {item.description && (
                                                                            <p style={{
                                                                                margin: 0,
                                                                                color: item.background_image_title_color || 'black',
                                                                                fontSize: '18px',
                                                                                fontWeight: '500',
                                                                                wordWrap: 'break-word'
                                                                            }}>
                                                                                {item.description}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : null}

                                                        {/* Media content for non-review posts */}
                                                        {!isReviewPost && !isBackgroundImagePost && (
                                                            <FeedMediaContent
                                                                post={item}
                                                                index={index}
                                                                activeSlide={activeSlide}
                                                                sliderSettings={sliderSettings}
                                                                initializeVideo={initializeVideo}
                                                                globalMute={globalMute}
                                                                toggleMute={toggleMute}
                                                                videomute={videomute}
                                                                videounmute={videounmute}
                                                                getActionTypeColor={getActionTypeColor}
                                                                saveScrollPosition={saveScrollPosition}
                                                            />
                                                        )}

                                                        <div className="post-content-text">
                                                            <div className="feed-actions">
                                                                <div className="left-icons">
                                                                    <img src={hearticon} alt="heart icon" className="heart" onClick={() => setDownloadPopupOpen(true)} /><span>{item.likes > 0 ? item.likes : ''}</span>
                                                                    <p className="post-vertical-line">|</p>
                                                                    <img
                                                                        src={commenticon}
                                                                        alt="comment icon"
                                                                        className="comment"
                                                                        onClick={() => {
                                                                            if (isUserLoggedIn()) {
                                                                                setShowCommentBox(prev => ({
                                                                                    ...prev,
                                                                                    [item.id]: !prev[item.id]
                                                                                }));
                                                                            } else {
                                                                                setDownloadPopupOpen(true);
                                                                            }
                                                                        }}
                                                                    /><span>{item.comments_count > 0 ? item.comments_count : ''}</span>
                                                                    <p className="post-vertical-line">|</p>
                                                                    <img src={shareicon} alt="share icon" className="shareicon" onClick={() => setDownloadPopupOpen(true)} /><span></span>
                                                                </div>
                                                                <img src={save} alt="save" id="save" onClick={() => setDownloadPopupOpen(true)} />
                                                            </div>

                                                            {isReviewPost ? (
                                                                <div className="review-timestamp"></div>
                                                            ) : !isBackgroundImagePost ? (
                                                                <div className="feed-caption">
                                                                    {item.description && (() => {
                                                                        const descTruncateLength = 180;
                                                                        const shouldTruncate = item.description.length > descTruncateLength;
                                                                        const isExpanded = expand[item.id];

                                                                        return (
                                                                            <p className={`feed-caption-text ${isExpanded ? "expanded" : ""}`}>
                                                                                {isExpanded
                                                                                    ? item.description
                                                                                    : shouldTruncate
                                                                                        ? `${item.description.substring(0, descTruncateLength)}... `
                                                                                        : item.description
                                                                                }

                                                                                {shouldTruncate && (
                                                                                    <span
                                                                                        className="feed-caption-toggle"
                                                                                        onClick={() =>
                                                                                            setExpand(prev => ({
                                                                                                ...prev,
                                                                                                [item.id]: !prev[item.id]
                                                                                            }))
                                                                                        }
                                                                                    >
                                                                                        {isExpanded ? "Less" : "More"}
                                                                                    </span>
                                                                                )}
                                                                            </p>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            ) : null}

                                                            {/* Comment box */}
                                                            {isUserLoggedIn() && showCommentBox[item.id] && (
                                                                <div className="home-post-comment-input">
                                                                    <p>comments</p>
                                                                    <div className="home-comment-input-wrapper">
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Share your thoughts..."
                                                                            autoFocus
                                                                        />
                                                                        <div className="home-comment-icons">
                                                                            <img src={linkicon} alt="link icon" />
                                                                            <img src={emoji} alt="emoji icon" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {loading && (index + 1) % 10 === 0 && (
                                                        <div className="loading-container">
                                                            <div className="loader-spinner"></div>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}

                                        {/* End of feed message */}
                                        {!hasMore && !loading && followingPosts.length > 0 && !isInitialLoading && (
                                            <div className="end-of-feed">
                                                You've reached the end of your feed
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        {/* {activeTab === "connections" && <div>Connections Content</div>} */}

                    </div>
                </main>


                <aside className="right-section">
                    {/* Download App section */}
                    {/* <div className="download-app">
                        <div className="hayaticon">
                            <img src={hayatlogo} alt="Hayat In Logo" />
                            <a href="#close" className="close-btn">
                                <img src={xmark} alt="xmark" className="xmark" />
                            </a>
                        </div>
                        <h4>Download Hayat In App</h4>

                        <div className="store-buttons">
                            <div className="app_qr">
                                <a
                                    href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={app_store} alt="App Store" />
                                </a>

                                <a
                                    href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={play_store} alt="Google Play" />
                                </a>
                            </div>


                            <div className="app_qr">
                                <img className="qr" src={qr} alt="QR code" />
                            </div>
                        </div>
                    </div> */}

                    <div>
                        <img
                            src={AiImage}
                            className="ai-image"
                            alt="Ai-Img"
                        />
                    </div>

                    {/* Trending Section */}
                    {trendingBrands.length > 0 && (
                        <div className="trending-section">
                            <h3
                                onClick={() => navigate("/business-and-brands")}
                                style={{ cursor: "pointer" }}
                            >
                                Trending
                                <span id="rightarrow" onClick={() => navigate("/business-and-brands")}>
                                    <img id="rightarrow-img" src={rightarrow} alt="rightarrow" />
                                </span>
                            </h3>

                            {trendingBrands.map((brand, index) => {
                                const brandImage = brand.profile_image || brand.cover_image;
                                const brandName = brand.name || brand.user_name;
                                const distance = brand.distance ? `${brand.distance.toFixed(1)} km` : "";
                                const location = brand.city || brand.location || "";
                                const locationText = distance && location ? `${distance} | ${location}` : location || distance || "";
                                const rating = brand.rating || brand.rating_value;

                                // Only render if we have essential data
                                if (!brandImage || !brandName) return null;

                                return (
                                    <div className="trend-card" key={brand.id || index}>
                                        <Link
                                            to={`/vendordetails/${brand.id || brand.user_id}`}
                                            className="remove-underline"
                                            onClick={saveScrollPosition}
                                        >
                                            <img
                                                src={brandImage}
                                                alt={brandName}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </Link>
                                        <div className="trend-info">
                                            <Link
                                                to={`/vendordetails/${brand.id || brand.user_id}`}
                                                className="remove-underline"
                                                onClick={saveScrollPosition}
                                            >
                                                <h4>{brandName}</h4>
                                            </Link>
                                            {locationText && <p>{locationText}</p>}
                                        </div>
                                        <div className="follow-rating">
                                            <button
                                                className="follow-btn home-right-section"
                                                onClick={() => setDownloadPopupOpen(true)}
                                            >
                                                Follow
                                            </button>
                                            {rating && (
                                                <span className="rating">
                                                    <span id="rating-no">{rating}</span> ★
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Connections Section  */}
                    {/* <div className="connections-section">
                        <div className="connections-header">
                            <h3>Connections<span id="rightarrow"><img id="rightarrow-img" src={rightarrow} alt="rightarrow" /></span></h3>
                        </div>

                        <div className="connection-card">
                            <img src={pic1} alt="pic1" />
                            <p>Najm Al-Barq</p>
                            <button className="connect-btn">Connect</button>
                        </div>
                        <div className="connection-card">
                            <img src={pic2} alt="pic2" />
                            <p>Lina</p>
                            <button className="connect-btn">Connect</button>
                        </div>
                        <div className="connection-card">
                            <img src={pic3} alt="pic3" />
                            <p>Amal Zakariya</p>
                            <button className="connect-btn">Connect</button>
                        </div>
                        <div className="connection-card">
                            <img src={pic4} alt="pic4" />
                            <p>Khalid Ayman</p>
                            <button className="connect-btn">Connect</button>
                        </div>
                        <div className="connection-card">
                            <img src={pic5} alt="pic5" />
                            <p>Muhamed Rayan</p>
                            <button className="connect-btn">Connect</button>
                        </div>
                        <div className="connection-card">
                            <img src={pic6} alt="pic6" />
                            <p>Amal Nour Bin</p>
                            <button className="connect-btn">Connect</button>
                        </div>

                    </div> */}
                </aside>
            </div>

            {/* {!hideFooter && (
                <footer className="footer-section">
                    <div className="footer-buttons">
                        <button className="create-account-btn" onClick={navigatetoregisterpage}>
                            Create Account
                        </button>
                        <button className="sign-in-btn" onClick={navigatetologinpage}>
                            Sign In
                        </button>
                    </div>
                </footer>
            )} */}
            {postpopup && (
                <div className="popup-overlay" onClick={() => setPostpopup(false)}>
                    <div className="popup-box" ref={popupRef} onClick={(e) => e.stopPropagation()}>

                        <div className="popup-options">
                            <Link to="/HomeCarouselOffer" className="remove-underline">
                                <div className="popup-item">
                                    <img src={campopup} alt="Post" />
                                    <p>Post</p>
                                </div>
                            </Link>

                            <div className="popup-item">
                                <img src={vidpopup} alt="Video" />
                                <p>Video</p>
                            </div>

                            <div className="popup-item">
                                <img src={carouselpopup} alt="Carousel" />
                                <p>Carousel</p>
                            </div>

                            <div className="popup-item">
                                <img src={offerpopup} alt="Offer" />
                                <p>Offer</p>
                            </div>

                            <div className="popup-item">
                                <img src={spotlightpopup} alt="Spotlight" />
                                <p>Spotlight</p>
                            </div>

                            <div className="popup-item">
                                <img src={eventpopup} alt="Event" />
                                <p>Event</p>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {downloadPopupOpen && (
                <>
                    <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.
                                </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>


                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )}
        </div>
    )
}

export default Home
